export const lang = {
  app: {
    NAME: 'app.name',
    SEARCH: 'app.search',
    OK: 'app.ok',
    YES: 'app.yes',
    NO: 'app.no',
    HOMEPAGE: 'app.homePage',
    GO_TO_HOMEPAGE: 'app.goToHomePage',
    ADD: 'app.add',
    ADD_NEW: 'app.addNew',
    EDIT: 'app.edit',
    SAVE: 'app.save',
    DELETE: 'app.delete',
    CONFIRMATION: 'app.confirmation',
    ACCEPT: 'app.accept',
    CANCEL: 'app.cancel',
    CLEAN: 'app.clean',
    SELECT: 'app.select',
    CHOOSE: 'app.choose',
    READY: 'app.ready',
    RESTART: 'app.restart',
    PREV: 'app.prev',
    NEXT: 'app.next',
    STOP: 'app.stop',
    FINISH: 'app.finish',
    COMPLETE: 'app.complete',
    SHOW: 'app.show',
    HIDE: 'app.hide',
    PIN: 'app.pin',
    COLOR: 'app.color',
    PICK_COLOR: 'app.pickColor',
    PROCESSING: 'app.processing',
    SUCCESSFUL: 'app.successful',
    WARNING: 'app.warning',
    PLEASE_WAIT: 'app.pleaseWait',
    LOADING: 'app.loading',
    SHOW_MORE: 'app.showMore',
    SCROLL_TO_TOP: 'app.scrollToTop',
    NO_DATA_AVAILABLE: 'app.noDataAvailable',
    ALL_DATA_LOADED: 'app.allDataLoaded',
    TOTAL_CONTENT_COUNT: 'app.totalContentCount',
    URL: 'app.url',
    YOU_NEED_TO_ENTER_VALID_URL_TO_SAVE: 'app.youNeedToEnterValidUrlToSave',
    LINK: 'app.link',
    SUBMIT: 'app.submit',
    PREVIEW: 'app.preview',
    SAVE_AND_STAY: 'app.saveAndStay',
    SAVE_AND_EXIT: 'app.saveAndExit',
    SEND_AND_EXIT: 'app.sendAndExit',
    SAVED_SUCCESSFULLY: 'app.savedSuccessfully',
    SAVE_FAILED: 'app.saveFailed',
    UPLOAD_FAILED: 'app.uploadFailed',
    SAVE_ERROR: 'app.saveError',
    ALL: 'app.all',
    SPECIAL: 'app.special',
    DOWNLOAD: 'app.download',
    OTHER: 'app.other',
    NORMAL: 'app.normal',
    COMING_SOON: 'app.comingSoon',
    SETTINGS: 'app.settings',
    COPY_TO_CLIPBOARD: 'app.copyToClipboard',
    SUCCESSFULLY_COPIED_TO_CLIPBOARD: 'app.successfullyCopiedToClipboard',
    LANGUAGE_SELECTED: 'app.languageSelected',
    FEATURE_FLAGS: 'app.featureFlags',
    TURBO_ADVERTISEMENT: 'app.turboAdvertisement',
    TURBO_ADVERTISEMENT_DESCRIPTION: 'app.turboAdvertisementDescription',
    TOURNAMENTS: 'app.tournaments',
    TOURNAMENT_SETTINGS_DESCRIPTION: 'app.tournamentSettingsDescription',
    SELECT_TOURNAMENTS: 'app.selectTournaments',
    NO_TOURNAMENT_FOUND: 'app.noTournamentFound',
    NO_TOURNAMENT_SELECTED: 'app.noTournamentSelected',
    UNKNOWN_TOURNAMENT: 'app.unknownTournament',
    REMOVE_TOURNAMENT: 'app.removeTournament',
    TOURNAMENTS_SELECTED: 'app.tournamentsSelected',
    TOURNAMENTS_LOAD_FAILED: 'app.tournamentsLoadFailed',
    FAVOURITE_TOURNAMENTS: 'app.favouriteTournaments',
    DEFAULT_TOURNAMENT: 'app.defaultTournament',
    DEFAULT_STANDING: 'app.defaultStanding',
    DEFAULT_TOURNAMENT_REQUIRED_FOR_STANDING: 'app.defaultTournamentRequiredForStanding',
    FAVOURITE_TOURNAMENT_SETTINGS_DESCRIPTION: 'app.favouriteTournamentSettingsDescription',
    ACTIVE: 'app.active',
    PASSIVE: 'app.passive',
    ARE_YOU_SURE: 'app.areYouSure',
    ARE_YOU_SURE_YOU_WANT_TO_CHANGE: 'app.areYouSureYouWantToChange',
    ARE_YOU_SURE_YOU_WANT_TO_REMOVE: 'app.areYouSureYouWantToRemove',
    ARE_YOU_SURE_YOU_WANT_TO_REMOVE_THIS_ACTION_CANNOT_BE_UNDONE: 'app.areYouSureYouWantToRemoveThisActionCannotBeUndone',
    ARE_YOU_SURE_YOU_WANT_TO_CANCEL: 'app.areYouSureYouWantToCancel',
    UNDO_UNSAVED_CHANGES: 'app.undoUnsavedChanges',
    YOUR_UNSAVED_CHANGES_WILL_BE_LOST_ARE_YOU_SURE: 'app.yourUnsavedChangesWillBeLostAreYouSure',
    YOU_ENTERED_AN_INVALID_VALUE: 'app.youEnteredAnInvalidValue',
    PLEASE_MAKE_SURE_YOU_ENTERED_ALL_FIELDS_CORRECTLY: 'app.pleaseMakeSureYouEnteredAllFieldsCorrectly',
    YOUR_CHANGES_WILL_BE_LOST_ARE_YOU_SURE: 'app.yourChangesWillBeLostAreYouSure',
    ERROR: 'app.error',
    COULD_NOT_CONNECT_SERVER: 'app.couldNotConnectServer',
    TOO_MANY_REQUESTS: 'app.tooManyRequests',
    PAGE_NOT_FOUND: 'app.pageNotFound',
    WAITING: 'app.waiting',
    SENT: 'app.sent',
    FAILED: 'app.failed',
    CANCELED: 'app.canceled',
    HI: 'app.hi',
    DESCRIPTION: 'app.description',
    LINK_COPIED_TO_CLIPBOARD: 'app.linkCopiedToClipboard',
    REDIRECT_URL: 'app.redirectUrl',
    DOWNLOAD_FILE: 'app.downloadFile',
    OTHER_SETTINGS: 'app.otherSettings',
    MAKE_YOUR_CHOICE: 'app.makeYourChoice',
    DRAG_AND_DROP_IS_NOT_POSSIBLE_IN_THIS_AREA: 'app.dragAndDropIsNotPossibleInThisArea',
  },
  editorsHandbook: {
    EDITORS_HANDBOOK: 'editorsHandbook.editorsHandbook',
    I_READ_AND_ACCEPTED: 'editorsHandbook.iReadAndAccepted',
    I_READ_I_UNDERSTAND_AND_I_WILL_APPLY: 'editorsHandbook.iReadIUnderstandAndApply',
    I_READ_I_UNDERSTAND_AND_I_WILL_APPLY_TEXT: 'editorsHandbook.iReadIUnderstandAndApplyText',
  },
  draft: {
    THERE_IS_A_DRAFT_OF_THE_CONTENT_YOU_WANT_TO_EDIT: 'draft.thereIsADraftOfTheContentYouWantToEdit',
    DRAFT_DATE: 'draft.draftDate',
    SAVE_AS_DRAFT: 'draft.saveAsDraft',
    YOUR_CONTENT_HAS_BEEN_SAVED_AS_DRAFT: 'draft.yourContentHasBeenSavedAsDraft',
  },
  site: {
    SITE: 'site.site',
    SITES: 'site.sites',
    SHOW_ON_WEBSITE: 'site.showOnWebsite',
    YENISAFAK: 'site.yeniSafak',
    YENISAFAK_EN: 'site.yeniSafakEn',
    YENISAFAK_AR: 'site.yeniSafakAr',
    GZT: 'site.gzt',
    TVNET: 'site.tvNet',
  },
  auth: {
    LOGOUT: 'auth.logout',
    LOGOUT_PROMPT_QUESTION: 'auth.logoutPromptQuestion',
    NO_AUTHORIZATION: 'auth.noAuthorization',
    PHO_ACCESS_DENIED_MESSAGE: 'auth.phoAccessDeniedMessage',
    UNAUTHORIZED_PAGE_MESSAGE: 'auth.unauthorizedPageMessage',
    AUTHORIZATION_FAILED: 'auth.authorizationFailed',
  },
  person: {
    PERSON_TYPE: 'person.personType',
    PERSONAL_INFO: 'person.personalInfo',
    NAME_AND_SURNAME: 'person.nameAndSurname',
    NAME: 'person.name',
    SURNAME: 'person.surname',
    NICKNAME: 'person.nickName',
    EMAIL: 'person.email',
    TYPE_A_NAME: 'person.typeAName',
    PROFILE_PHOTO: 'person.profilePhoto',
    PLEASE_UPLOAD_PROFILE_PHOTO: 'person.pleaseUploadProfilePhoto',
    CHANGE_PROFILE_PHOTO: 'person.changeProfilePhoto',
    SELECT_PROFILE_PHOTO: 'person.selectProfilePhoto',
    CREATED_BY: 'person.createdBy',
    UPDATED_BY: 'person.updatedBy',
    BIRTH_DATE: 'person.birthDate',
    DATE_OF_DEATH: 'person.dateOfDeath',
    AGE: 'person.age',
    BURIAL_PLACE: 'person.burialPlace',
    JOB: 'person.job',
    EDUCATION: 'person.education',
    MISSION: 'person.mission',
    NATIONALITY: 'person.nationality',
    MARITAL_STATUS: 'person.maritalStatus',
    MARRIAGE: 'person.marriage',
    EDIT_MARRIAGE_INFO: 'person.editMarriageInfo',
    MARRIAGE_DATE: 'person.marriageDate',
    DIVORCE_DATE: 'person.divorceDate',
    MARRIAGE_DATE_NOT_ENTERED: 'person.marriageDateNotEntered',
    THERE_IS_NO_INFO_OR_NOT_ENTERED: 'person.thereIsNoInfoOrNotEntered',
    DIVORCE_DATE_CANNOT_BE_ENTERED_WITHOUT_MARRIAGE_DATE: 'person.divorceDateCannotBeEnteredWithoutMarriageDate',
    MARRIAGE_INFO_SAVED_SUCCESSFULLY: 'person.marriageInfoSavedSuccessfully',
    CHILDREN: 'person.children',
    CHILD: 'person.child',
    DESCENDANTS: 'person.descendants',
    DESCENDANT: 'person.descendant',
    PARENTS: 'person.parents',
    PARENT: 'person.parent',
    SIBLINGS: 'person.siblings',
    SIBLING: 'person.sibling',
    FOUNDED_ORGANIZATIONS: 'person.foundedOrganizations',
    AWARDS: 'person.awards',
    BOOKS: 'person.books',
    EDIT_RELATION_ORDER: 'person.editRelationOrder',
  },
  user: {
    USER: 'user.user',
    USERS: 'user.users',
    ADD_NEW_USER: 'user.addNewUser',
    EDIT_USERS_INFO: 'user.editUsersInfo',
    USERNAME: 'user.username',
    DEPARTMENT: 'user.department',
    ROLES: 'user.roles',
    PERMISSIONS: 'user.permissions',
    USER_PICTURE: 'user.userPicture',
    ALL_USERS: 'user.allUsers',
    APPROVED_USERS: 'user.approvedUsers',
    UNAPPROVED_USERS: 'user.unapprovedUsers',
    UPDATE_FROM_SERVER: 'user.updateFromServer',
    UPDATE_FROM_SERVER_PROMPT: 'user.updateFromServerPrompt',
    USER_ADDED: 'user.userAdded',
    USER_INFORMATION_UPDATED: 'user.userInformationUpdated',
    USER_ALREADY_ADDED: 'user.userAlreadyAdded',
    SELECT_USER: 'user.selectUser',
    USER_SELECTED: 'user.userSelected',
    NO_USER_SELECTED: 'user.noUserSelected',
    AN_ERROR_OCCURRED_WHILE_SAVING_USER: 'user.anErrorOccurredWhileSavingUser',
    USER_NOT_FOUND_PLEASE_LOGIN_AGAIN: 'user.userNotFoundPleaseLoginAgain',
    CREATOR: 'user.creator',
  },
  author: {
    AUTHOR: 'author.author',
    AUTHOR_GENERATED: 'author.authorGenerated',
    AUTHORS: 'author.authors',
    AUTHOR_NAME: 'author.authorName',
    AUTHOR_SURNAME: 'author.authorSurname',
    AUTHOR_LIST: 'author.authorList',
    NEWSPAPER_AUTHOR_LIST: 'author.newspaperAuthorList',
    NEWSPAPER_AUTHOR_GENERATED: 'author.newspaperAuthorGenerated',
    SPORT_AUTHOR_LIST: 'author.sportAuthorList',
    SPORT_AUTHOR_GENERATED: 'author.sportAuthorGenerated',
    ARCHIVE_AUTHOR_LIST: 'author.archiveAuthorList',
    ARCHIVE_AUTHOR_GENERATED: 'author.archiveAuthorGenerated',
    ADD_NEW_AUTHOR: 'author.addNewAuthor',
    ADD_AUTHOR: 'author.addAuthor',
    APPROVED_AUTHORS: 'author.approvedAuthors',
    UNAPPROVED_AUTHORS: 'author.unapprovedAuthors',
    YOUR_AUTHOR_TO_ADD_UNAPPROVED: 'author.yourAuthorToAddUnapproved',
    SQUARE_PROFILE_PHOTO: 'author.squareProfilePhoto',
    HORIZONTAL_PROFILE_PHOTO: 'author.horizontalProfilePhoto',
  },
  authorTypes: {
    NEWSPAPER: 'authorTypes.newspaper',
    INTERNET: 'authorTypes.internet',
    OPINION: 'authorTypes.opinion',
  },
  cartoonist: {
    CARTOONIST: 'cartoonist.cartoonist',
    CARTOONIST_GENERATED: 'cartoonist.cartoonistGenerated',
    CARTOONISTS: 'cartoonist.cartoonists',
    CARTOONIST_LIST: 'cartoonist.cartoonistList',
    ADD_CARTOONIST: 'cartoonist.addCartoonist',
    ADD_NEW_CARTOONIST: 'cartoonist.addNewCartoonist',
    CARTOONIST_NAME: 'cartoonist.cartoonistName',
    APPROVED_CARTOONIST: 'cartoonist.approvedCartoonist',
    UNAPPROVED_CARTOONIST: 'cartoonist.unapprovedCartoonist',
    YOUR_CARTOONIST_TO_ADD_UNAPPROVED: 'cartoonist.yourCartoonistToAddUnapproved',
  },
  brand: {
    BRAND: 'brand.brand',
    BRANDS: 'brand.brands',
    BRAND_LIST: 'brand.brandList',
    ADD_BRAND: 'brand.addBrand',
    ADD_NEW_BRAND: 'brand.addNewBrand',
    APPROVED_BRANDS: 'brand.approvedBrands',
    UNAPPROVED_BRANDS: 'brand.unapprovedBrands',
    BRAND_INFO: 'brand.brandInfo',
    BRAND_NAME: 'brand.brandName',
    BRAND_LOGO: 'brand.brandLogo',
    BRAND_LOGO_DARK: 'brand.brandLogoDark',
    BRAND_BANNER: 'brand.brandBanner',
    SELECT_BRAND_LOGO: 'brand.selectBrandLogo',
    CHANGE_BRAND_LOGO: 'brand.changeBrandLogo',
    SELECT_BRAND_DARK_LOGO: 'brand.selectBrandDarkLogo',
    CHANGE_BRAND_DARK_LOGO: 'brand.changeBrandDarkLogo',
    SELECT_BRAND_BANNER: 'brand.selectBrandBanner',
    CHANGE_BRAND_BANNER: 'brand.changeBrandBanner',
    YOUR_BRAND_TO_ADD_UNAPPROVED: 'brand.yourBrandToAddUnapproved',
    BRAND_DATA_SOURCE: 'brand.brandDataSource',
  },
  recipe: {
    INGREDIENTS: 'recipe.ingredients',
    INGREDIENT: 'recipe.ingredient',
    INGREDIENT_NAME: 'recipe.ingredientName',
    INGREDIENT_SELECTION: 'recipe.ingredientSelection',
    INGREDIENT_AMOUNT: 'recipe.ingredientAmount',
    INGREDIENT_AMOUNT_PLACEHOLDER: 'recipe.ingredientAmountPlaceholder',
    BRAND_SELECTION: 'recipe.brandSelection',
    CUISINE: 'recipe.cuisine',
    MEAL_TYPE: 'recipe.mealType',
    MEASUREMENT: 'recipe.measurement',
    UTENSILS: 'recipe.utensils',
    UTENSIL: 'recipe.utensil',
    HEALTHY_LIVES: 'recipe.healthyLives',
    STEP: 'recipe.step',
    STEP_NOT_ASSIGNED: 'recipe.stepNotAssigned',
    RAYON: 'recipe.rayon',
    INGREDIENT_TYPE: 'recipe.ingredientType',
    BRAND_NAME: 'recipe.brandName',
    BRAND_URL: 'recipe.brandUrl',
    EDITOR_SELECTION: 'recipe.editorSelection',
    HAS_PREPARATION_PHOTOS: 'recipe.hasPreparationPhotos',
    HAS_NO_PREPARATION_PHOTOS: 'recipe.hasNoPreparationPhotos',
    RECIPE_LIST: 'recipe.recipeList',
    DRAFT_RECIPE_LIST: 'recipe.draftRecipeList',
    CHEF_SELECTION: 'recipe.chefSelection',
    CHEF_LABEL: 'recipe.chefLabel',
    MEAL_TYPE_LABEL: 'recipe.mealTypeLabel',
    DIFFICULTY: 'recipe.difficulty',
    CUISINE_LABEL: 'recipe.cuisineLabel',
    SEARCH_VALUE_LABEL: 'recipe.searchValueLabel',
    SEARCH_VALUE_PLACEHOLDER: 'recipe.searchValuePlaceholder',
    ALTERNATIVE_RECIPES: 'recipe.alternativeRecipes',
    ALTERNATIVE_RECIPES_HINT: 'recipe.alternativeRecipesHint',
    ALTERNATIVE_RECIPES_MANUAL_INFO: 'recipe.alternativeRecipesManualInfo',
    ALTERNATIVE_RECIPES_ADDED_COUNT: 'recipe.alternativeRecipesAddedCount',
    ALTERNATIVE_RECIPES_LIMIT_REACHED: 'recipe.alternativeRecipesLimitReached',
    ADD_ALTERNATIVE_RECIPE: 'recipe.addAlternativeRecipe',
    REMOVE_ALTERNATIVE_RECIPE: 'recipe.removeAlternativeRecipe',
    NO_ALTERNATIVE_RECIPES: 'recipe.noAlternativeRecipes',
    SEARCH_FILTER_TITLE: 'recipe.searchFilterTitle',
    SEARCH_FILTER_INFO: 'recipe.searchFilterInfo',
    SEARCH_FILTER_HOW_IT_WORKS: 'recipe.searchFilterHowItWorks',
    SEARCH_FILTER_APPLIED_NOTE: 'recipe.searchFilterAppliedNote',
    SEARCH_FILTER_QUOTA_FULL: 'recipe.searchFilterQuotaFull',
    OPTIONAL_LABEL: 'recipe.optionalLabel',
    ACTIVE_LABEL: 'recipe.activeLabel',
    MAGAZINE_COUNT: 'recipe.magazineCount',
    RECIPE_DATE: 'recipe.recipeDate',
    DURATIONS: 'recipe.durations',
    PREPARATION_TIME: 'recipe.preparationTime',
    COOKING_TIME: 'recipe.cookingTime',
    RESTING_TIME: 'recipe.restingTime',
    SERVING_COUNT: 'recipe.servingCount',
    SUGGESTIONS_AND_NOTES: 'recipe.suggestionsAndNotes',
    ADDITIONAL_INFO: 'recipe.additionalInfo',
    TIPS: 'recipe.tips',
    SERVING_SUGGESTIONS: 'recipe.servingSuggestions',
    FAQ: 'recipe.faq',
    FAQ_QUESTION: 'recipe.faqQuestion',
    FAQ_ANSWER: 'recipe.faqAnswer',
    FAQ_ADD: 'recipe.faqAdd',
    NUTRITIONAL_VALUES: 'recipe.nutritionalValues',
    NUTRITIONAL_VALUES_PER_100G: 'recipe.nutritionalValuesPer100g',
    NUTRITIONAL_VALUE_ADD: 'recipe.nutritionalValueAdd',
    PREPARATION_CARDS: 'recipe.preparationCards',
    ADD_CONTENT: 'recipe.addContent',
    ADD_MEDIA: 'recipe.addMedia',
    ADD_HINT: 'recipe.addHint',
    STEP_SELECTION: 'recipe.stepSelection',
    NO_INGREDIENTS_FOR_STEP: 'recipe.noIngredientsForStep',
    INGREDIENTS_FOR_THIS_STEP: 'recipe.ingredientsForThisStep',
    UTENSILS_FOR_THIS_STEP: 'recipe.utensilsForThisStep',
    ADD_DESCRIPTION: 'recipe.addDescription',
    PHOTOS: 'recipe.photos',
    DOWNLOAD_ALL_PHOTOS: 'recipe.downloadAllPhotos',
    AN_ERROR_OCCURRED_WHILE_DOWNLOADING_PHOTOS: 'recipe.anErrorOccurredWhileDownloadingPhotos',
    VIDEO: 'recipe.video',
    UPLOAD_VIDEO: 'recipe.uploadVideo',
    CLEAR: 'recipe.clear',
    PLEASE_SELECT_STEP: 'recipe.pleaseSelectStep',
    DESCRIPTION_MIN_LENGTH: 'recipe.descriptionMinLength',
    CARD: 'recipe.card',
    INGREDIENT_BRAND: 'recipe.ingredientBrand',
    GRAM: 'recipe.gram',
    AMOUNT: 'recipe.amount',
    APPROVAL: 'recipe.approval',
    UNIT_EQUIVALENT: 'recipe.unitEquivalent',
    UNIT: 'recipe.unit',
    GRAM_EQUIVALENT: 'recipe.gramEquivalent',
    RAYON_UNIT: 'recipe.rayonUnit',
    ACTION: 'recipe.action',
    NAME: 'recipe.name',
    SHORT_NAME: 'recipe.shortName',
    STATUS: 'recipe.status',
    CALORIE: 'recipe.calorie',
    ENERGY: 'recipe.energy',
    FAT: 'recipe.fat',
    CARBOHYDRATE: 'recipe.carbohydrate',
    PROTEIN: 'recipe.protein',
    SATURATED_FAT: 'recipe.saturatedFat',
    SUGAR: 'recipe.sugar',
    SALT: 'recipe.salt',
    WATER: 'recipe.water',
    FIBRE: 'recipe.fibre',
    CHOLESTEROL: 'recipe.cholesterol',
    SODIUM: 'recipe.sodium',
    POTASSIUM: 'recipe.potassium',
    CALCIUM: 'recipe.calcium',
    IRON: 'recipe.iron',
    PHOSPHORUS: 'recipe.phosphorus',
    MAGNESIUM: 'recipe.magnesium',
    FOLIC_ACID: 'recipe.folicAcid',
    VITAMIN_A: 'recipe.vitaminA',
    VITAMIN_C: 'recipe.vitaminC',
    VITAMIN_E: 'recipe.vitaminE',
    VITAMIN_B1: 'recipe.vitaminB1',
    VITAMIN_B2: 'recipe.vitaminB2',
    VITAMIN_B3: 'recipe.vitaminB3',
    VITAMIN_B5: 'recipe.vitaminB5',
    VITAMIN_B6: 'recipe.vitaminB6',
    VITAMIN_B12: 'recipe.vitaminB12',
    NUTRITION: 'recipe.nutrition',
    VALUE: 'recipe.value',
    DIFFICULTY_EASY: 'recipe.difficultyEasy',
    DIFFICULTY_MEDIUM: 'recipe.difficultyMedium',
    DIFFICULTY_HARD: 'recipe.difficultyHard',
    CALCULATE_NUTRITION: 'recipe.calculateNutrition',
    CALCULATE_NUTRITION_LOADING: 'recipe.calculateNutritionLoading',
    NUTRITION_PREVIEW_TITLE: 'recipe.nutritionPreviewTitle',
    NUTRITION_PREVIEW_APPLY: 'recipe.nutritionPreviewApply',
    NUTRITION_PREVIEW_RECALCULATE: 'recipe.nutritionPreviewRecalculate',
    NUTRITION_PREVIEW_CANCEL: 'recipe.nutritionPreviewCancel',
    NUTRITION_PREVIEW_TOTAL: 'recipe.nutritionPreviewTotal',
    NUTRITION_PREVIEW_PER_SERVING: 'recipe.nutritionPreviewPerServing',
    NUTRITION_PREVIEW_PER_100G: 'recipe.nutritionPreviewPer100g',
    NUTRITION_PER_100G_BASIS: 'recipe.nutritionPer100gBasis',
    NUTRITION_PREVIEW_VIEW_MODE: 'recipe.nutritionPreviewViewMode',
    NUTRITION_PREVIEW_INGREDIENT: 'recipe.nutritionPreviewIngredient',
    NUTRITION_PREVIEW_GRAM: 'recipe.nutritionPreviewGram',
    NUTRITION_PREVIEW_WARNINGS: 'recipe.nutritionPreviewWarnings',
    NUTRITION_PROVENANCE_AI: 'recipe.nutritionProvenanceAi',
    NUTRITION_PROVENANCE_INGREDIENT_AI: 'recipe.nutritionProvenanceIngredientAi',
    NUTRITION_PROVENANCE_MANUAL: 'recipe.nutritionProvenanceManual',
    NUTRITION_PROVENANCE_UNKNOWN: 'recipe.nutritionProvenanceUnknown',
    RECALCULATION_REASON_TITLE: 'recipe.recalculationReasonTitle',
    RECALCULATION_REASON_PLACEHOLDER: 'recipe.recalculationReasonPlaceholder',
    RECALCULATION_REASON_CONFIRM: 'recipe.recalculationReasonConfirm',
    RECALCULATION_REASON_CANCEL: 'recipe.recalculationReasonCancel',
    INGREDIENT_CALCULATE_NUTRITION: 'recipe.ingredientCalculateNutrition',
    INGREDIENT_AI_NUTRITION_HEADER: 'recipe.ingredientAiNutritionHeader',
    INGREDIENT_AI_NUTRITION_CALCULATED_AT: 'recipe.ingredientAiNutritionCalculatedAt',
    NUTRITION_ERROR_VALIDATION: 'recipe.nutritionErrorValidation',
    NUTRITION_ERROR_CONTENT_FILTER: 'recipe.nutritionErrorContentFilter',
    NUTRITION_ERROR_PARSE: 'recipe.nutritionErrorParse',
    NUTRITION_ERROR_INCOMPLETE: 'recipe.nutritionErrorIncomplete',
    NUTRITION_ERROR_RATE_LIMIT: 'recipe.nutritionErrorRateLimit',
    NUTRITION_ERROR_TIMEOUT: 'recipe.nutritionErrorTimeout',
    NUTRITION_ERROR_INTERNAL: 'recipe.nutritionErrorInternal',
    NUTRITION_ERROR_DETAILS: 'recipe.nutritionErrorDetails',
    NUTRITION_RETRY: 'recipe.nutritionRetry',
    NUTRITION_GROUP_MACROS: 'recipe.nutritionGroupMacros',
    NUTRITION_GROUP_MINERALS: 'recipe.nutritionGroupMinerals',
    NUTRITION_GROUP_VITAMINS: 'recipe.nutritionGroupVitamins',
    NUTRITION_TOTALS_HEADER: 'recipe.nutritionTotalsHeader',
    NUTRITION_RECALCULATE_INGREDIENT: 'recipe.nutritionRecalculateIngredient',
    NUTRITION_RECALCULATE_ALL: 'recipe.nutritionRecalculateAll',
    DELETE_INGREDIENT_CONFIRM: 'recipe.deleteIngredientConfirm',
    DELETE_PREPARATION_CARD_CONFIRM: 'recipe.deletePreparationCardConfirm',
  },
  userQueue: {
    USER_PERMITTED_MESSAGE: 'userQueue.userPermittedMessage',
    USER_PERMITTED_ON_ANOTHER_WINDOW_MESSAGE: 'userQueue.userPermittedOnAnotherWindowMessage',
    USER_NOT_PERMITTED_MESSAGE: 'userQueue.userNotPermittedMessage',
    NETWORK_DISCONNECTED: 'userQueue.networkDisconnected',
    NETWORK_DISCONNECTED_INFORMATION: 'userQueue.networkDisconnectedInformation',
    FAILED_TO_ACCESS_ACTIVE_USER_INFORMATION: 'userQueue.failedToAccessActiveUserInformation',
    PERMIT_REQUEST_SENT_TO_USER: 'userQueue.permitRequestSentToUser',
    AN_ERROR_OCCURRED_WHILE_SENDING_PERMIT_REQUEST: 'userQueue.anErrorOccurredWhileSendingPermitRequest',
    USER_REQUESTED_PERMIT_FOR_THIS_OPERATION: 'userQueue.userRequestedPermitForThisOperation',
    PERMIT_ACCEPTED_FOR_THIS_OPERATION: 'userQueue.permitAcceptedForThisOperation',
    PERMIT_DECLINED_FOR_THIS_OPERATION: 'userQueue.permitDeclinedForThisOperation',
    PERMIT_REQUESTED_BY_ANOTHER_USER_FOR_THIS_OPERATION: 'userQueue.permitRequestedByAnotherUserForThisOperation',
    PERMIT_HAS_ALREADY_BEEN_REQUESTED_FOR_THIS_OPERATION: 'userQueue.permitHasAlreadyBeenRequestedForThisOperation',
    PERMIT_GIVEN_TO_USER_FOR_THIS_OPERATION: 'userQueue.permitGivenToUserForThisOperation',
    PERMIT_DID_NOT_GIVEN_TO_USER_FOR_THIS_OPERATION: 'userQueue.permitDidNotGivenToUserForThisOperation',
    AN_ERROR_OCCURRED_WHILE_ANSWERING_PERMIT_REQUEST: 'userQueue.anErrorOccurredWhileAnsweringPermitRequest',
    CONTENT_UPDATED_BY_ACTIVE_USER: 'userQueue.contentUpdatedByActiveUser',
    ANOTHER_USER: 'userQueue.anotherUser',
    CONTENT_UPDATED_AUTOMATICALLY: 'userQueue.contentUpdatedAutomatically',
    PERMISSION_WILL_BE_GRANTED_TO_USER_ARE_YOU_SURE: 'userQueue.permissionWillBeGrantedToUserAreYouSure',
    YOU_WERE_KICKED_FROM_THE_PAGE_BY_USER: 'userQueue.youWereKickedFromThePageByUser',
    ALL_USERS_VIEWING_THIS_PAGE_HAVE_LEFT_THE_PAGE: 'userQueue.allUsersViewingThisPageHaveLeftThePage',
    SELECT_THE_USER_YOU_WILL_PERMIT_ON_THIS_OPERATION: 'userQueue.selectTheUserYouWillPermitOnThisOperation',
  },
  date: {
    DATE: 'date.date',
    TYPE_DATE: 'date.typeDate',
    TIME: 'date.time',
    YEAR: 'date.year',
    MONTH: 'date.month',
    WEEK: 'date.week',
    DAY: 'date.day',
    HOUR: 'date.hour',
    MINUTE: 'date.minute',
    SECOND: 'date.second',
    START_DATE: 'date.startDate',
    START_DATE_CANNOT_BE_CHOSEN_GREATER_THAN_END_DATE: 'date.startDateCannotBeChosenGreaterThanEndDate',
    END_DATE: 'date.endDate',
    END_DATE_CANNOT_BE_EMPTY: 'date.endDateCannotBeEmpty',
    END_TIME: 'date.endTime',
    END_TIME_CANNOT_BE_EMPTY: 'date.endTimeCannotBeEmpty',
    DATE_RANGE: 'date.dateRange',
    PUBLISH_DATE: 'date.publishDate',
    EXPIRATION_DATE: 'date.expirationDate',
    SEND_DATE: 'date.sendDate',
    CREATED_DATE: 'date.createdDate',
    DAYS_OF_WEEK: {
      MONDAY: 'date.daysOfWeek.monday',
      TUESDAY: 'date.daysOfWeek.tuesday',
      WEDNESDAY: 'date.daysOfWeek.wednesday',
      THURSDAY: 'date.daysOfWeek.thursday',
      FRIDAY: 'date.daysOfWeek.friday',
      SATURDAY: 'date.daysOfWeek.saturday',
      SUNDAY: 'date.daysOfWeek.sunday',
    },
    TWO_DATES_SELECTED: 'date.twoDatesSelected',
  },
  unit: {
    WIDTH: 'unit.width',
    HEIGHT: 'unit.height',
    WIDTH_ALTERNATE: 'unit.widthAlternate',
    HEIGHT_ALTERNATE: 'unit.heightAlternate',
    WIDTH_AND_HEIGHT: 'unit.widthAndHeight',
  },
  file: {
    FILE: 'file.file',
    FILE_CAPTION: 'file.fileCaption',
    FILE_NOT_EXIST: 'file.fileNotExist',
    FILE_SIZE: 'file.fileSize',
    UPLOAD_FILE: 'file.uploadFile',
    UPLOADING: 'file.uploading',
    ARE_YOU_SURE_YOU_WANT_TO_CANCEL_UPLOAD: 'file.areYouSureYouWantToCancelUpload',
    ARE_YOU_SURE_YOU_WANT_TO_CANCEL_UPLOAD_IN_PROGRESS: 'file.areYouSureYouWantToCancelUploadInProgress',
    FILE_FORMAT_YOU_SELECTED_IS_NOT_SUITABLE: 'file.fileFormatYouSelectedIsNotSuitable',
    FILES_UPLOADING_WAIT_OR_CANCEL_TO_SAVE: 'file.filesUploadingWaitOrCancelToSave',
    SELECT_FILE: 'file.selectFile',
    ARE_YOU_SURE_YOU_WANT_TO_CHANGE_FILE: 'file.areYouSureYouWantToChangeFile',
    UPLOAD_IN_PROGRESS: 'file.uploadInProgress',
    CANCEL_UPLOAD_FILE: 'file.cancelUploadFile',
    ARE_YOU_SURE_YOU_WANT_TO_REMOVE_SELECTED_FILE: 'file.areYouSureYouWantToRemoveSelectedFile',
    ARE_YOU_SURE_YOU_WANT_TO_UPLOAD_FILE_BIGGER_THAN_SUGGESTED_MAX_SIZE: 'file.areYouSureYouWantToUploadFileBiggerThanSuggestedMaxSize',
    FILE_SIZE_SHOULD_NOT_BE_BIGGER_THAN_SUGGESTED_MAX_SIZE: 'file.fileSizeShouldNotBeBiggerThanSuggestedMaxSize',
    YOU_HAVE_NOT_SELECTED_ANY_FILE_YET: 'file.youHaveNotSelectedAnyFilesYet',
    YOU_CAN_ONLY_UPLOAD_VIDEO_OR_IMAGE: 'file.youCanOnlyUploadVideoOrImage',
    DRAG_AND_DROP_THE_FILES_YOU_WANT_TO_UPLOAD: 'file.dragAndDropTheFilesYouWantToUploadHere',
    UPLOADED_FILES_ARE_BEING_PROCESSED_PLEASE_WAIT: 'file.uploadedFilesAreBeingProcessedPleaseWait',
  },
  cropper: {
    RECROP: 'cropper.recrop',
    CROP_IMAGE: 'cropper.cropImage',
    CROP_CANCEL_PROMPT_QUESTION: 'cropper.cropCancelPromptQuestion',
    CROP_SETTINGS: 'cropper.cropSettings',
    FREE_RATIO: 'cropper.freeRatio',
  },
  status: {
    STATUS: 'status.status',
    STATUS_APPROVE: 'status.statusApprove',
    STATUS_UNAPPROVE: 'status.statusUnapprove',
    SHORT_STATUS_APPROVE: 'status.shortStatusApprove',
    SHORT_STATUS_UNAPPROVE: 'status.shortStatusUnapprove',
    SELECT_STATUS: 'status.selectStatus',
    APPROVED: 'status.approved',
    APPROVE: 'status.approve',
    APPROVE_STATUS: 'status.approveStatus',
  },
  comment: {
    STATUS: {
      PENDING: 'comment.status.pending',
      APPROVED: 'comment.status.approved',
      DISAPPROVED: 'comment.status.disapproved',
      REMOVED: 'comment.status.removed',
    },
    ANONYMOUS: 'comment.anonymous',
    TITLE: 'comment.title',
    BODY: 'comment.body',
    USER: 'comment.user',
    CREATED_AT: 'comment.createdAt',
    STATUS_DESC: 'comment.statusDesc',
    ACTIONS: 'comment.actions',
    REPORT_COUNT: 'comment.reportCount',
    COMMENTS: 'comment.comments',
    REPORTED_COMMENTS: 'comment.reportedComments',
  },
  content: {
    CONTENT: 'content.content',
    CONTENTS: 'content.contents',
    CONTENT_MANAGEMENT: 'content.contentManagement',
    CONTENT_LIST: 'content.contentList',
    DRAFT_CONTENT_LIST: 'content.draftContentList',
    PENDING_CONTENTS: 'content.pendingContents',
    SIGNED_CONTENTS: 'content.signedContents',
    CONTENT_SETTINGS: 'content.contentSettings',
    CONTENT_DETAIL: 'content.contentDetail',
    NEWS: 'content.news',
    ADD_NEWS: 'content.addNews',
    CREATE_NEWS: 'content.createNews',
    ADD_PHOTO_GALLERY: 'content.addPhotoGallery',
    CREATE_PHOTO_GALLERY: 'content.createPhotoGallery',
    CREATE_INFOGRAPHIC: 'content.createInfographic',
    CREATE_NEWSPAPER: 'content.createNewspaper',
    ADD_COLUMN: 'content.addColumn',
    ADD_CARTOON: 'content.addCartoon',
    ADD_INFOGRAPHIC: 'content.addInfographic',
    ADD_PROMOTION: 'content.addPromotion',
    ADD_PODCAST: 'content.addPodcast',
    ADD_OFFICIAL_ANNOUNCEMENT: 'content.addofficialAnnouncement',
    SELECTED_CONTENTS: 'content.selectedContents',
    GO_TO_CONTENT: 'content.goToContent',
    CONTENT_TYPE: 'content.contentType',
    CONTENT_QUANTITY: 'content.contentQuantity',
    CONTENT_DATE: 'content.contentDate',
    CHANGE_CONTENT_TYPE_QUESTION: 'content.contentTypeChangeQuestion',
    UPLOAD_GALLERY: 'content.uploadGallery',
    UPLOAD_INFOGRAPHIC: 'content.uploadInfographic',
    ORDER: 'content.order',
    ORDER_CANNOT_BE_EMPTY: 'content.orderCannotBeEmpty',
    TITLE: 'content.title',
    SPOT: 'content.spot',
    TITLE_AND_SPOT: 'content.titleAndSpot',
    CAPTION: 'content.caption',
    TEXT: 'content.text',
    ADD_TEXT: 'content.addText',
    ENTER_TEXT: 'content.enterText',
    ADD_URL: 'content.addUrl',
    CATEGORY: 'content.category',
    CATEGORY_GENERATED: 'content.categoryGenerated',
    MAIN_CATEGORY: 'content.mainCategory',
    PARENT_CATEGORY: 'content.parentCategory',
    CATEGORIES: 'content.categories',
    CATEGORY_LIST: 'content.categoryList',
    CATEGORY_ID: 'content.categoryId',
    CATEGORY_NAME: 'content.categoryName',
    ADD_CATEGORY: 'content.addCategory',
    ADD_NEW_CATEGORY: 'content.addNewCategory',
    APPROVED_CATEGORIES: 'content.approvedCategories',
    UNAPPROVED_CATEGORIES: 'content.unapprovedCategories',
    SELECTED_CATEGORIES: 'content.selectedCategories',
    LIST_SUB_CATEGORIES: 'content.listSubCategories',
    YOUR_CATEGORY_TO_ADD_UNAPPROVED: 'content.yourCategoryToAddUnapproved',
    CHEFS_CHOICE: 'content.chefsChoice',
    DESCRIPTION: 'content.description',
    EDITOR: 'content.editor',
    AGENCY: 'content.agency',
    GO_TO_AGENCY_CONTENT: 'content.goToAgencyContent',
    ABOUT: 'content.about',
    LINKNAME: 'content.linkname',
    ADDITIONAL_NOTE: 'content.additionalNote',
    ADVERTISEMENT: 'content.advertisement',
    ADD_ADVERTISEMENT: 'content.addAdvertisement',
    EDIT_ADVERTISEMENT: 'content.editAdvertisement',
    EXTERNAL_LINK: 'content.externalLink',
    ADD_EXTERNAL_LINK: 'content.addExternalLink',
    ADD_LIVE_BROADCAST: 'content.addLiveBroadcast',
    CONTENTS_MAY_INTEREST: 'content.contentsMayInterest',
    CONTENT_SELECTION: 'content.contentSelection',
    SMILE: 'content.smile',
    SEO_TITLE: 'content.seoTitle',
    SEO_URL_TITLE: 'content.seoUrlTitle',
    SEO_SPOT: 'content.seoSpot',
    SEO_KEYWORD: 'content.seoKeyword',
    MAGAZINE_QUOTE: 'content.magazineQuote',
    ENTER_TAG: 'content.enterTag',
    TAG: 'content.tag',
    EDIT_TAG_ORDER: 'content.editTagOrder',
    TAG_RECOMMENDATIONS: 'content.tagRecommendations',
    FINISH_EDITING: 'content.finishEditing',
    LITERARY_WORK: 'content.literaryWork',
    INCIDENT: 'content.incident',
    CONTENT_NOT_FOUND: 'content.contentNotFound',
    INVALID_CONTENT_ID: 'content.invalidContentId',
    TOTAL_CONTENT_COUNT: 'content.totalContentCount',
    CONTENT_ID: 'content.contentId',
    SERIE: 'content.serie',
    THIS_CONTENT_UPDATING_BY_ANOTHER_USER: 'content.thisContentUpdatingByAnotherUser',
    THIS_CONTENT_UPDATING_BY_ANOTHER_USER_ARE_YOU_SURE: 'content.thisContentUpdatingByAnotherUserAreYouSure',
    PIN_CONTENT: 'content.pinContent',
    THIS_CONTENT_WILL_ONLY_BE_PINNED_ON_PHO: 'content.thisContentWillOnlyBePinnedOnPho',
    ARE_YOU_SURE_YOU_WANT_TO_CANCEL_PIN: 'content.areYouSureYouWantToCancelPin',
    ADD_TABLE_OF_CONTENT: 'content.addTableOfContent',
    USERS_UPDATED_CONTENT: 'content.usersUpdatedContent',
    SHOW_IN_HOMEPAGE: 'content.showInHomepage',
    ANNOUNCEMENT_NUMBER: 'content.announcementNumber',
    SHRINK_TABLE_CONTENT: 'content.shrinkTableContent',
    SPORTS_CATEGORY: 'content.sportsCategory',
    SHOW_ADVERTISEMENTS: 'content.showAdvertisements',
    HIDE_FROM_NEWS_FEED: 'content.hideFromNewsFeed',
    ADVERTISEMENT_VISIBILITY_FROM_CONTENT: 'content.advertisementVisibilityFromContent',
    CONTENT_CREATION_DISABLED: 'content.contentCreationDisabled',
    CONTENT_CREATION_DISABLED_FOR_CATEGORIES: 'content.contentCreationDisabledForCategories',
    THERE_IS_UNSAVED_CONTENT_CHANGES_WILL_NOT_APPEAR_ON_WEBSITE: 'content.thereIsUnsavedContentChangesWillNotAppearOnWebsite',
    YOU_MAY_NOT_BE_ABLE_TO_VIEW_CONTENT_BECAUSE_STATUS_IS_UNAPPROVED:
      'content.youMayNotBeAbleToViewContentBecauseStatusIsUnapproved',
    ADD_CONTENT: 'content.addContent',
    IS_NEWS_WORTHY: 'content.isNewsWorthy',
    ANNOUNCEMENT_ORDER: 'content.announcementOrder',
    PAGE_NUMBER: 'content.pageNumber',
    CHANNEL: 'content.channel',
    MEDIUM: 'content.medium',
    CATEGORY_URI: 'content.categoryUri',
    TITLE_REQUIRED_BEFORE_UPLOAD: 'content.titleRequiredBeforeUpload'
  },
  seoContent: {
    SEO_CONTENTS: 'seoContent.seoContents',
    SEO_CONTENTS_LIST: 'seoContent.seoContentsList',
    DRAFT_SEO_CONTENTS_LIST: 'seoContent.draftSeoContentsList',
    HADITH: 'seoContent.hadith',
    HADITHS: 'seoContent.hadiths',
    DREAM_INTERPRETATION: 'seoContent.dreamInterpretation',
    DREAM_INTERPRETATIONS: 'seoContent.dreamInterpretations',
    DUA: 'seoContent.dua',
    FATWA: 'seoContent.fatwa',
    TRANSLATED_BIG_CEVSEN: 'seoContent.translatedBigCevsen',
    MAIN_SUBJECT_TITLE: 'seoContent.mainSubjectTitle',
    SUBJECT_TITLE: 'seoContent.subjectTitle',
    ADD_SUBJECT_TITLE: 'seoContent.addSubjectTitle',
    THERE_IS_ANOTHER_CONTENT_CREATED_WITH_THIS_SUBJECT: 'seoContent.thereIsAnotherContentCreatedWithThisSubject',
    SUBJECT_TITLE_ADDED_SUCCESSFULLY: 'seoContent.subjectTitleAddedSuccessfully',
    AN_ERROR_OCCURRED_WHILE_ADDING_SUBJECT: 'seoContent.anErrorOccurredWhileAddingSubject',
    BOOK: 'seoContent.book',
    HADITH_MANAGEMENT: 'seoContent.hadithManagement',
    HADITH_LIST: 'seoContent.hadithList',
    HADITH_NO: 'seoContent.hadithNo',
    HADITH_SOURCE: 'seoContent.hadithSource',
    NARRATOR: 'seoContent.narrator',
    DREAM_INTERPRETATION_MANAGEMENT: 'seoContent.dreamInterpretationManagement',
    ADD_DREAM_INTERPRETATION: 'seoContent.addDreamInterpretation',
    DUA_MANAGEMENT: 'seoContent.duaManagement',
    ADD_DUA: 'seoContent.addDua',
    FATWA_MANAGEMENT: 'seoContent.fatwaManagement',
    ADD_FATWA: 'seoContent.addFatwa',
  },
  relatedContent: {
    ADD_RELATED_CONTENT: 'relatedContent.addRelatedContent',
    NO_RELATED_CONTENT_SELECTED: 'relatedContent.noRelatedContentSelected',
  },
  footballEmbed: {
    ADD_FOOTBALL_EMBED: 'footballEmbed.addFootballEmbed',
    NO_FOOTBALL_EMBED_SELECTED: 'footballEmbed.noFootballEmbedSelected',
    POINTS: 'footballEmbed.points',
    FIXTURE: 'footballEmbed.fixture',
    GOAL: 'footballEmbed.goal',
    ASSIST: 'footballEmbed.assist',
    COUNTRY: 'footballEmbed.country',
    LEAGUE: 'footballEmbed.league',
    WEEK: 'footballEmbed.week',
  },
  mailingWidget: {
    SPORT_FIXTURE: 'mailingWidget.sportFixture',
    ADD_SPORT_FIXTURE: 'mailingWidget.addSportFixture',
    SPORT_FIXTURE_DESCRIPTION: 'mailingWidget.sportFixtureDescription',
    SPORT_FIXTURE_MULTI_DESCRIPTION: 'mailingWidget.sportFixtureMultiDescription',
    RENDER_WARNINGS: 'mailingWidget.renderWarnings',
    EDIT_SPORT_FIXTURE: 'mailingWidget.editSportFixture',
    DEFAULT_LEAGUE: 'mailingWidget.defaultLeague',
    SELECTED_LEAGUE: 'mailingWidget.selectedLeague',
    NO_LEAGUE_FOUND: 'mailingWidget.noLeagueFound',
  },
  newsType: {
    NEWS_TYPE: 'newsType.newsType',
    NEWS_TYPE_HOT: 'newsType.newsTypeHot',
    NEWS_TYPE_COLD: 'newsType.newsTypeCold',
    NEWS_TYPE_NEWSPAPER: 'newsType.newsTypeNewspaper',
    NEWS_TYPE_NONE: 'newsType.newsTypeNone',
  },
  pdf: {
    ADD_PDF: 'pdf.addPdf',
    UPLOAD_PDF: 'pdf.uploadPdf',
    CHANGE_PDF: 'pdf.changePdf',
    UNABLE_TO_DISPLAY_PDF_FILE: 'pdf.unableToDisplayPdfFile',
    PLEASE_ADD_A_PDF: 'pdf.pleaseAddAPdf',
  },
  media: {
    ADD_MEDIA: 'media.addMedia',
  },
  image: {
    IMAGE: 'image.image',
    ADD_IMAGE: 'image.addImage',
    PLEASE_ADD_AN_IMAGE: 'image.pleaseAddAnImage',
    SELECT_IMAGE: 'image.selectImage',
    DELETE_IMAGE: 'image.deleteImage',
    IMAGE_INFORMATION: 'image.imageInformation',
    ENTER_AN_IMAGE_CAPTION: 'image.enterAnImageCaption',
    ENTER_AN_IMAGE_SOURCE: 'image.enterAnImageSource',
    ENTER_AN_IMAGE_LINK: 'image.enterAnImageLink',
    ALT_TEXT: 'image.altText',
    ENTER_AN_IMAGE_ALT_TEXT: 'image.enterAnImageAltText',
    ENTER_THE_CAPTION_INFORMATION_IN_THE_I_BUTTON: 'image.enterTheCaptionInformationInTheIButton',
    PLEASE_FILL_IN_THE_CAPTION_FIELD: 'image.pleaseFillInTheCaptionField',
    UPLOAD_IMAGE: 'image.uploadImage',
    CHANGE_IMAGE: 'image.changeImage',
    CHECK_IMAGE_SIZE_ALERT: 'image.checkImageSizeAlert',
    CHECK_IMAGE_MAX_SIZE_ALERT: 'image.checkImageMaxSizeAlert',
    CHECK_IMAGE_FILE_TYPE_ALERT: 'image.checkImageFileTypeAlert',
    PLEASE_SELECT_IMAGE_TO_UPLOAD: 'image.pleaseSelectImageToUpload',
    THE_IMAGES_YOU_SELECTED_WILL_NOT_BE_UPLOADED_ARE_YOU_SURE: 'image.theImagesYouSelectedWillNotBeUploadedAreYouSure',
  },
  video: {
    VIDEO: 'video.video',
    ADD_VIDEO: 'video.addVideo',
    PLEASE_ADD_A_VIDEO: 'video.pleaseAddAVideo',
    DELETE_VIDEO: 'video.deleteVideo',
    CHANGE_VIDEO: 'video.changeVideo',
    VIDEO_INFORMATION: 'video.videoInformation',
    ENTER_AN_VIDEO_CAPTION: 'video.enterAnVideoCaption',
    ENTER_AN_VIDEO_SOURCE: 'video.enterAnVideoSource',
    VIDEO_CAMERAMAN: 'video.videoCameraman',
    ENTER_A_VIDEO_CAMERAMAN: 'video.enterAVideoCameraman',
    ENTER_THE_CAPTION_INFORMATION_IN_THE_I_BUTTON: 'video.enterTheCaptionInformationInTheIButton',
    PLEASE_FILL_IN_THE_CAPTION_FIELD: 'video.pleaseFillInTheCaptionField',
    CREATE_VIDEO: 'video.createVideo',
    SUGGESTED_VIDEO: 'video.suggestedVideo',
    SELECT_VIDEO: 'video.selectVideo',
    SELECT_THE_VIDEO_YOU_WANT_TO_UPLOAD: 'video.selectTheVideoYouWantToUpload',
    UPLOAD_VIDEO: 'video.uploadVideo',
    VIDEO_DURATION: 'video.videoDuration',
    PLEASE_CHECK_VIDEO_SIZE: 'video.pleaseCheckVideoSize',
    DRAG_AND_DROP_THE_VIDEO_YOU_WANT_TO_UPLOAD: 'video.dragAndDropTheVideoYouWantToUploadHere',
    VIDEO_PROCESSING_INFORMATION_TEXT: 'video.videoProcessingInformationText',
    VIDEO_UPLOADED_AND_PROCESSING_INFORMATION_TEXT: 'video.videoUploadedAndProcessingInformationText',
    SEARCH_VIDEO_CONTENT: 'video.searchVideoContent',
    NO_VIDEO_SELECTED: 'video.noVideoSelected',
    ADD_TO_REELS: 'video.addToReels',
  },
  verseStop: {
    ADD_VERSE_STOP: 'verseStop.addVerseStop',
    PLEASE_CHECK_VERSE_CODE: 'verseStop.checkVerseCode',
    ADD_STOP: 'verseStop.addStop',
  },
  embed: {
    EMBED: 'embed.embed',
    ADD_EMBED: 'embed.addEmbed',
    EMBED_VIDEO: 'embed.embedVideo',
    EMBED_CODE: 'embed.embedCode',
    ENTER_EMBED_CODE: 'embed.enterEmbedCode',
    EMBED_CAPTION: 'embed.embedCaption',
    ENTER_EMBED_CAPTION: 'embed.enterEmbedCaption',
    PLEASE_CHECK_EMBED_CODE: 'embed.pleaseCheckEmbedCode',
    ADD_EMBEDDED_VIDEO: 'embed.addEmbeddedVideo',
    YOU_CAN_COPY_VIDEO_EMBED_CODE: 'embed.youCanCopyVideoEmbedCode',
    CODE: 'embed.code',
    COPY_EMBED_CODE: 'embed.copyEmbedCode',
    PLEASE_PASTE_A_VALID_EMBED_CODE_BELOW: 'embed.pleasePasteAValidEmbedCodeBelow',
    PLEASE_ENTER_A_VALID_EMBED_CODE: 'embed.pleaseEnterAValidEmbedCode',
    ADD_TVNET_LIVE_BROADCAST: 'embed.addTvnetLiveBroadcast',
  },
  coverImage: {
    COVER_IMAGE: 'coverImage.coverImage',
    COVER_IMAGE_INFORMATION: 'coverImage.coverImageInformation',
    COVER_IMAGE_LINK: 'coverImage.coverImageLink',
    ADD_COVER_IMAGE: 'coverImage.addCoverImage',
    SELECT_COVER_IMAGE: 'coverImage.selectCoverImage',
    DELETE_COVER_IMAGE: 'coverImage.deleteCoverImage',
    SET_AS_COVER_IMAGE: 'coverImage.setAsCoverImage',
    PLEASE_SELECT_A_COVER_IMAGE: 'coverImage.pleaseSelectACoverImage',
    PLEASE_ENTER_COVER_IMAGE_DESCRIPTION: 'coverImage.pleaseEnterCoverImageDescription',
    ARE_YOU_SURE_YOU_WANT_TO_CHANGE_THE_COVER_IMAGE: 'coverImage.areYouSureYouWantToChangeTheCoverImage',
    ARE_YOU_SURE_YOU_WANT_TO_REMOVE_THE_COVER_IMAGE: 'coverImage.areYouSureYouWantToRemoveTheCoverImage',
    YOU_MUST_UPLOAD_OR_SELECT_A_COVER_IMAGE: 'coverImage.youMustUploadOrSelectACoverImage',
    FLASH_NEWS_COVER_IMAGE: 'coverImage.flashNewsCoverImage',
    DOWNLOAD_ORIGINAL_IMAGE: 'coverImage.downloadOriginalImage',
  },
  coverVideo: {
    COVER_VIDEO: 'coverVideo.coverVideo',
    COVER_VIDEO_SELECTION: 'coverVideo.coverVideoSelection',
  },
  coverGif: {
    COVER_GIF: 'coverGif.coverGif',
    CHANGE_GIF: 'coverGif.changeGif',
    ADD_GIF: 'coverGif.addGif',
  },
  photoGallery: {
    ENTER_DESCRIPTION_BY_PRESSING_T_ICON: 'photoGallery.enterDescriptionByPressingTIcon',
    PHOTO_REPORTER: 'photoGallery.photoReporter',
    PLEASE_ENTER_PHOTO_REPORTER: 'photoGallery.pleaseEnterPhotoReporter',
    AT_LEAST_TWO_CONTENT_MUST_BE_ADDED_TO_COMPLETE_SAVE_PROCESS: 'photoGallery.atLeastTwoContentMustBeAddedToCompleteSaveProcess',
  },
  sports: {
    LIVE_TRANSFER: {
      LIVE_TRANSFER: 'sports.liveTransfer.liveTransfer',
      LIVE_TRANSFER_LIST: 'sports.liveTransfer.liveTransferList',
      ADD_LIVE_TRANSFER: 'sports.liveTransfer.addNewLiveTransfer',
      LINK_NAME: 'sports.liveTransfer.linkName',
      OFFICIAL: 'sports.liveTransfer.official',
      UNOFFICIAL: 'sports.liveTransfer.unofficial',
      FEE: 'sports.liveTransfer.fee',
      CURRENCY: 'sports.liveTransfer.currency',
      LOAN_PLAYER: 'sports.liveTransfer.loanPlayer',
    },
    LEAGUE: 'sports.league',
    TEAM: 'sports.team',
  },
  headline: {
    HEADLINE: 'headline.headline',
    LOKMA_HEADLINE: 'headline.lokmaHeadline',
    HEADLINE_TYPES: 'headline.headlineTypes',
    HEADLINE_CATEGORIES: 'headline.headlineCategories',
    HEADLINE_SETTINGS: 'headline.headlineSettings',
    UPLOAD_IMAGES_FOR_ALL_SIZES: 'headline.uploadImagesForAllSizes',
    FULL_HEADLINE: 'headline.fullHeadline',
    HEADLINE_MANAGEMENT: 'headline.headlineManagement',
    HEADLINE_NEWS: 'headline.headlineNews',
    OUT_OF_HEADLINE: 'headline.outOfHeadline',
    HEADLINE_TYPE: 'headline.headlineType',
    ADD_HEADLINE_TYPE: 'headline.addHeadlineType',
    HEADLINE_TYPE_LIST: 'headline.headlineTypeList',
    APPROVED_HEADLINE_TYPES: 'headline.approvedHeadlineTypes',
    UNAPPROVED_HEADLINE_TYPES: 'headline.unapprovedHeadlineTypes',
    HEADLINE_TYPE_NAME: 'headline.headlineTypeName',
    ADD_NEW_HEADLINE_TYPE: 'headline.addNewHeadlineType',
    HEADLINE_ARCHIVE_SETTINGS: 'headline.headlineArchiveSettings',
    ADD_HEADLINES_TO_ARCHIVE_IN_THIS_HEADLINE_TYPE: 'headline.addHeadlinesToArchiveInThisHeadlineType',
    HEADLINE_DATE: 'headline.headlineDate',
    HIDE_TITLE_AND_SPOT_FIELDS: 'headline.hideTitleAndSpotFields',
    HEADLINE_ADDED: 'headline.headlineAdded',
    HEADLINE_SAVED: 'headline.headlineSaved',
    YOU_MUST_SELECT_HEADLINE_TO_SAVE: 'headline.youMustSelectHeadlineToSave',
    ADD_HEADLINE: 'headline.addHeadline',
    EDIT_HEADLINE: 'headline.editHeadline',
    DELETE_HEADLINE: 'headline.deleteHeadline',
    HEADLINE_DELETED: 'headline.headlineDeleted',
    ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_HEADLINE: 'headline.areYouSureYouWantToDeleteThisHeadline',
    BREAKING_NEWS: 'headline.breakingNews',
    PIN_HEADLINE: 'headline.pinHeadline',
    UNPIN_HEADLINE: 'headline.unpinHeadline',
    PIN_PERMANENTLY: 'headline.pinPermanently',
    ARE_YOU_SURE_YOU_WANT_TO_CANCEL_PIN: 'headline.areYouSureYouWantToCancelPin',
    EDIT_HEADLINE_TITLE_AND_SPOT: 'headline.editHeadlineTitleAndSpot',
    ADD_MANUAL_URL_TO_THE_HEADLINE: 'headline.addManualUrlToTheHeadline',
    OPEN_DETAIL_PAGE_IN_SITE: 'headline.openDetailPageInSite',
    UPDATE_HEADLINES_IMAGE: 'headline.updateHeadlinesImage',
    PIN_HEADLINE_TO_THIS_ORDER: 'headline.pinHeadlineToThisOrder',
    YOU_DIDNT_ADD_HEADLINE_CONTENT: 'headline.youDidntAddHeadlineContent',
    CHECK_THE_HEADLINE_ORDER: 'headline.checkTheHeadlineOrder',
    HEADLINE_ORDER: 'headline.headlineOrder',
    AUTO_HEADLINE_SETTINGS: 'headline.autoHeadlineSettings',
    AUTO_HEADLINE: 'headline.autoHeadline',
    ADD_HEADLINE_CONTENTS_TO_ANOTHER_HEADLINES: 'headline.addHeadlineContentsToAnotherHeadlines',
    TOTAL_CONTENT_DESCRIPTION: 'headline.totalContentDescription',
    SAME_HEADLINE_TYPE_NAME_BY_CATEGORY: 'headline.sameHeadlineTypeNameByCategory',
    YOU_DIDNT_CLICK_THE_APPROVE_BUTTON: 'headline.youDidntClickTheApproveButton',
    PLEASE_CHECK_HEADLINE_COVER_IMAGE_CROP_SETTINGS: 'headline.pleaseCheckHeadlineCoverImageCropSettings',
    FULL_HEADLINE_COVER_IMAGE_REQUIRED: 'headline.fullHeadlineCoverImageRequired',
    AUTOMATIC_HEADLINE_CATEGORY: 'headline.automaticHeadlineCategory',
    AUTOMATIC_HEADLINE_CONTENT_TYPE: 'headline.automaticHeadlineContentType',
    AUTOMATIC_HEADLINE_CHANNEL: 'headline.automaticHeadlineChannel',
    TOTAL_CONTENT_COUNT_CANT_BE_LESS_CONTENT_COUNT: 'headline.totalContentCountCantBeLessContentCount',
    HEADLINE_CATEGORY_LIST: 'headline.headlineCategoryList',
    ADD_NEW_HEADLINE_CATEGORY: 'headline.addNewHeadlineCategory',
    ADD_HEADLINE_CATEGORY: 'headline.addHeadlineCategory',
    APPROVED_HEADLINE_CATEGORY: 'headline.approvedHeadlineCategory',
    UNAPPROVED_HEADLINE_CATEGORY: 'headline.unapprovedHeadlineCategory',
    HEADLINE_CATEGORY_NAME: 'headline.headlineCategoryName',
    HEADLINE_ORDER_HAS_BEEN_CHANGED: 'headline.headlineOrderHasBeenChanged',
    HEADLINE_ORDER_COULD_NOT_BE_CHANGED: 'headline.headlineOrderCouldNotBeChanged',
    YOUR_HEADLINE_CATEGORY_TO_ADD_UNAPPROVED: 'headline.yourHeadlineCategoryToAddUnapproved',
    SAME_HEADLINE_CATEGORY_NAME: 'headline.sameHeadlineCategoryName',
    THE_HEADLINE_ORDER_COULD_NOT_BE_LESS_THAN_ONE: 'headline.theHeadlineOrderCouldNotBeLessThanOne',
    CONTENT_ALREADY_ADDED_TO_HEADLINE: 'headline.contentAlreadyAddedToHeadline',
    ARE_YOU_SURE_YOU_WANT_TO_DELETE_CONTENT_FROM_HEADLINE: 'headline.areYouSureWantToDeleteContentFromHeadline',
    ARE_YOU_SURE_YOU_WANT_TO_DELETE_CONTENT_FROM_PENDING_HEADLINE: 'headline.areYouSureWantToDeleteContentFromPendingHeadline',
    PENDING_HEADLINES: 'headline.pendingHeadlines',
    PLEASE_CHOOSE_DIFFERENT_HEADLINE_DATE: 'headline.pleaseChooseDifferentHeadlineDate',
    PLEASE_CHECK_HEADLINE_DATE_OF_CONTENTS: 'headline.pleaseCheckHeadlineDateOfContents',
    PLEASE_CHECK_HEADLINE_ORDER_THIS_CANT_BE_SAME: 'headline.pleaseCheckHeadlineOrderThisCantBeSame',
    CONTENT_WITH_ID_IS_ALREADY_ON_HEADLINE_LIST: 'headline.contentWithIdIsAlreadyOnHeadlineList',
    CONTENT_WITH_ID_IS_ALREADY_ON_PENDING_HEADLINE_LIST: 'headline.contentWithIdIsAlreadyOnPendingHeadlineList',
    TO_ADD_CONTENT_TO_THE_HEADLINE_LIST_IT_MUST_BE_DELETED_FROM_POST_DATED_HEADLINE_LIST:
      'headline.toAddContentToTheHeadlineListItMustBeDeletedFromPostDatedHeadlineList',
    TO_ADD_CONTENT_TO_THE_POST_DATED_HEADLINE_LIST_IT_MUST_BE_DELETED_FROM_HEADLINE_LIST:
      'headline.toAddContentToThePostDatedHeadlineListItMustBeDeletedFromHeadlineList',
    PLEASE_SELECT_A_DIFFERENT_HEADLINE_DATE: 'headline.pleaseSelectADifferentHeadlineDate',
    THIS_CONTENT_WILL_BE_REMOVED_FROM_HEADLINE_TO_BE_ADDED_IN_TO_PENDING_HEADLINES:
      'headline.thisContentWillBeRemovedFromHeadlineToBeAddedInToPendingHeadlines',
    YOUR_HEADLINE_CATEGORY_LIST_TO_ADD_UNAPPROVED: 'headline.yourHeadlineCategoryListToAddUnapproved',
    AUTOMATICALLY_ADD_CONTENTS_WITH_THE_FOLLOWING_CONTENT_TYPES_OR_NEWS_TYPE:
      'headline.automaticallyAddContentsWithTheFollowingContentTypesOrNewsType',
    TO_THIS_HEADLINE: 'headline.toThisHeadline',
    THE_FOLLOWING_CONTENTS_WAS_ALSO_ADDED_TO_THESE_HEADLINES: 'headline.theFollowingContentsWasAlsoAddedToTheseHeadlines',
    THE_FOLLOWING_CONTENTS_COULD_NOT_BE_ADDED_BECAUSE_NOT_SUPPORTED: 'headline.theFollowingContentsCouldNotBeAddedBecauseNotSupported',
    REDIRECTED_AFTER_TEN_MINUTES_OF_INACTIVITY_ON_HEADLINE: 'headline.redirectedAfterTenMinutesOfInactivityOnHeadline',
    YOU_WILL_BE_REDIRECTED_TO_THE_HOMEPAGE_DUE_TO_INACTIVITY:
      'headline.youWillBeRedirectedToTheHomepageDueToInactivity',
  },
  headlineTag: {
    HEADLINE_TAG: 'headlineTag.headlineTag',
    HEADLINE_TAGS: 'headlineTag.headlineTags',
    HEADLINE_TAG_LIST: 'headlineTag.headlineTagList',
    ADD_NEW_HEADLINE_TAG: 'headlineTag.addNewHeadlineTag',
    HEADLINE_TAG_NAME: 'headlineTag.headlineTagName',
    APPROVED_HEADLINE_TAGS: 'headlineTag.approvedHeadlineTags',
    UNAPPROVED_HEADLINE_TAGS: 'headlineTag.unapprovedHeadlineTags',
    HEADLINE_TAG_NOT_APPROVED: 'headlineTag.headlineTagNotApproved',
    ADD_HEADLINE_TAG: 'headlineTag.addHeadlineTag',
    PRESS_ENTER_TO_CREATE: 'headlineTag.pressEnterToCreate',
  },
  notification: {
    NOTIFICATION: 'notification.notification',
    SEND_NOTIFICATION: 'notification.sendNotification',
    SEND_NOTIFICATION_WITH_PICTURE: 'notification.sendNotificationWithPicture',
    ALL_NOTIFICATIONS: 'notification.allNotifications',
    NOTIFICATION_DATE: 'notification.notificationDate',
    NOTIFICATION_TITLE_PROPER_LENGTH_MESSAGE: 'notification.notificationTitleProperLentgthMessage',
    NOTIFICATION_TITLE_OVER_LENGTH_MESSAGE: 'notification.notificationTitleOverLengthMessage',
    NOTIFICATION_SPOT_PROPER_LENGTH_MESSAGE: 'notification.notificationSpotProperLentgthMessage',
    NOTIFICATION_SPOT_OVER_LENGTH_MESSAGE: 'notification.notificationSpotOverLengthMessage',
    PLATFORMS_WILL_BE_SEND_NOTIFICATION: 'notification.platformsWillBeSendNotification',
    NOTIFICATION_WILL_BE_CANCELED: 'notification.notificationWillBeCanceled',
    NOTIFICATION_LIST: 'notification.notificationList',
    GO_TO_NOTIFICATION_DETAIL: 'notification.goToNotificationDetail',
    SENT_NOTIFICATIONS: 'notification.sentNotifications',
    SAVE_ERROR: 'notification.saveError',
    FAILED_PLATFORMS: 'notification.failedPlatforms',
    SHOW_IN_BREAKING_NEWS_AREA: 'notification.showInBreakingNewsArea',
    COVER_IMAGE_REQUIRED: 'notification.coverImageRequired',
  },
  notificationStatus: {
    NOTIFICATION_STATUS: 'notificationStatus.notificationStatus',
    ALL: 'notificationStatus.all',
    IMPORTANT_UPDATES: 'notificationStatus.importantUpdates',
    DAILY_UPDATES: 'notificationStatus.dailyUpdates',
    ONLY_CATEGORY_FOLLOWERS: 'notificationStatus.onlyCategoryFollowers',
  },
  signature: {
    SIGNATURE: 'signature.signature',
    SIGNATURES: 'signature.signatures',
    SIGNATURE_LIST: 'signature.signatureList',
    ADD_SIGNATURE: 'signature.addSignature',
    ADD_NEW_SIGNATURE: 'signature.addNewSignature',
    SIGNATURE_NAME: 'signature.signatureName',
    APPROVED_SIGNATURES: 'signature.approvedSignatures',
    UNAPPROVED_SIGNATURES: 'signature.unapprovedSignatures',
    YOUR_SIGNATURE_TO_ADD_UNAPPROVED: 'signature.yourSignatureToAddUnapproved',
  },
  chef: {
    CHEF: 'chef.chef',
    CHEFS: 'chef.chefs',
    CHEF_LIST: 'chef.chefList',
    ADD_CHEF: 'chef.addChef',
    ADD_NEW_CHEF: 'chef.addNewChef',
    CHEF_NAME: 'chef.chefName',
    APPROVED_CHEFS: 'chef.approvedChefs',
    UNAPPROVED_CHEFS: 'chef.unapprovedChefs',
    YOUR_CHEF_TO_ADD_UNAPPROVED: 'chef.yourChefToAddUnapproved',
  },
  source: {
    SOURCE: 'source.source',
    SOURCES: 'source.sources',
    SOURCE_LIST: 'source.sourceList',
    SOURCE_DETAIL: 'source.sourceDetail',
    SOURCE_NAME: 'source.sourceName',
    ADD_NEW_SOURCE: 'source.addNewSource',
    APPROVED_SOURCES: 'source.approvedSources',
    UNAPPROVED_SOURCES: 'source.unapprovedSources',
    ADD_SOURCE: 'source.addSource',
    YOUR_SOURCE_TO_ADD_UNAPPROVED: 'source.yourSourceToAddUnapproved',
  },
  program: {
    PROGRAM: 'program.program',
    PROGRAMS: 'program.programs',
    PROGRAM_LIST: 'program.programList',
    ADD_PROGRAM: 'program.addProgram',
    ADD_NEW_PROGRAM: 'program.addNewProgram',
    PROGRAM_NAME: 'program.programName',
    APPROVED_PROGRAMS: 'program.approvedPrograms',
    UNAPPROVED_PROGRAMS: 'program.unapprovedPrograms',
    PROGRAM_STATUS_SELECT: 'program.statusSelect',
    YOU_DIDNT_CLICK_THE_APPROVE_BUTTON: 'program.youDidntClickTheApproveButton',
    PLEASE_SELECT_TIME: 'program.pleaseSelectTime',
    PROGRAM_DAY_AND_TIME: 'program.programDayAndTime',
    ORDER: 'program.order'
  },
  socialMedia: {
    SOCIAL_MEDIA: 'socialMedia.socialMedia',
    SOCIAL_MEDIA_INFO: 'socialMedia.socialMediaInfo',
    GENERAL: 'socialMedia.general',
    FACEBOOK: 'socialMedia.facebook',
    TWITTER: 'socialMedia.twitter',
    X: 'socialMedia.x',
    INSTAGRAM: 'socialMedia.instagram',
    YOUTUBE: 'socialMedia.youtube',
    WHATSAPP: 'socialMedia.whatsapp',
    THREADS: 'socialMedia.threads',
    TELEGRAM: 'socialMedia.telegram',
    TIKTOK: 'socialMedia.tiktok',
    NEXT_SOCIAL: 'socialMedia.nextSocial',
    FACEBOOK_UTM_SOURCE: 'socialMedia.facebookUtmSource',
    TWITTER_UTM_SOURCE: 'socialMedia.twitterUtmSource',
    WHATSAPP_UTM_SOURCE: 'socialMedia.whatsappUtmSource',
    THREADS_UTM_SOURCE: 'socialMedia.threadsUtmSource',
    TELEGRAM_UTM_SOURCE: 'socialMedia.telegramUtmSource',
    NEXT_SOCIAL_UTM_SOURCE: 'socialMedia.nextSocialUtmSource',
    MARK_AS_SHARED_ON_SOCIAL_MEDIA_QUESTION: 'socialMedia.markAsSharedOnSocialMediaQuestion',
    SOCIAL_MEDIA_ACCOUNT: 'socialMedia.socialMediaAccount',
  },
  platform: {
    PLATFORM: 'platform.platform',
    PLATFORMS: 'platform.platforms',
    MOBILE_APP: 'platform.mobileApp',
    MOBILE_SITE: 'platform.mobileSite',
    SITE: 'platform.site',
    ALL: 'platform.all',
    SPECIAL: 'platform.special',
    OTHER: 'platform.other',
    WEB: 'platform.web',
    MAIL: 'platform.mail',
    MOBILE: 'platform.mobile',
    APPLICATION: 'platform.application',
  },
  promotion: {
    PROMOTION_TYPE: 'promotion.promotionType',
    WITH_PRODUCT_CONTENT: 'promotion.withProductContent',
    PUBLIC_SPOT: 'promotion.publicSpot',
  },
  podcast: {
    SEASON: 'podcast.season',
    EPISODE: 'podcast.episode',
  },
  mailing: {
    MAILING: 'mailing.mailing',
    LOKMA_MAILING: 'mailing.lokmaMailing',
    MAILING_NEWSLETTER: 'mailing.mailingNewsletter',
    MAILING_UPCOMING: 'mailing.mailingUpcoming',
    DRAFT_CUSTOM_MAILING_LIST: 'mailing.draftCustomMailingList',
    MAILING_SENT: 'mailing.mailingSent',
    PENDING_MAILING_LIST: 'mailing.pendingMailingList',
    MAILING_LIST: 'mailing.mailingList',
    CUSTOM_MAILING: 'mailing.customMailing',
    TYPE_MAILING: 'mailing.typeMailing',
    NEWSLETTER_TITLE: 'mailing.newsletterTitle',
    SAVE_TO_SEND: 'mailing.saveToSend',
    SITE_URL_NOT_FOUND: 'mailing.siteUrlNotFound',
    YOU_MUST_PICK_A_DATE_AND_TIME_TO_SAVE: 'mailing.youMustPickADateAndTimeToSave',
    YOU_MUST_PICK_A_VALID_DATE_AND_TIME: 'mailing.youMustPickAValidDateAndTime',
    YOU_MUST_ENTER_A_TITLE_TO_SAVE: 'mailing.youMustEnterATitleToSave',
    YOU_MUST_ADD_AT_LEAST_ONE_NEWS: 'mailing.youMustAddAtLeastOneNews',
    MAILING_SAVED: 'mailing.mailingSaved',
    MAILING_UPDATED: 'mailing.mailingUpdated',
    AN_ERROR_OCCURRED_WHILE_SAVING_MAILING: 'mailing.anErrorOccurredWhileSavingMailing',
    ADD_MAILING_DETAIL: 'mailing.addMailingDetail',
    YOU_MUST_SELECT_CONTENT_TO_SAVE: 'mailing.youMustSelectContentToSave',
    REMOVE_CONTENT_FROM_NEWSLETTER: 'mailing.removeContentFromNewsletter',
    ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_MAILING_DETAIL: 'mailing.areYouSureYouWantToDeleteThisMailingDetail',
    MAILING_SCHEDULED: 'mailing.mailingScheduled',
    MAILING_SAVED_BUT_NOT_SCHEDULED: 'mailing.mailingSavedButNotScheduled',
    CONTENT_ALREADY_ADDED_TO_NEWSLETTER: 'mailing.contentAlreadyAddedToNewsletter',
    CANCEL_NEWSLETTER: 'mailing.cancelNewsletter',
    ARE_YOU_SURE_YOU_WANT_TO_CANCEL_THIS_MAILING: 'mailing.areYouSureYouWantToCancelThisMailing',
    MAILING_CANCELED_AND_REMOVED: 'mailing.mailingCanceledAndRemoved',
    MAILING_CANCEL_FAILED: 'mailing.mailingCancelFailed',
    MAILING_MANAGEMENT: 'mailing.mailingManagement',
    NEWSLETTER_CHANNEL: 'mailing.newsletterChannel',
    ADD_MAILING: 'mailing.mailingAdd',
    EDIT_MAILING: 'mailing.mailingEdit',
    CREATE_CUSTOM_MAILING: 'mailing.createCustomMailing',
    SEND_PRIVATE_EMAIL_TO_USER: 'mailing.sendPrivateEmailToUser',
    CONTENT_SHARED_CHANNELS_YOU_FOLLOW: 'mailing.contentSharedChannelsYouFollow',
    STATUS_MAILING: 'mailing.statusMailing',
    INCLUDE_ARTICLES_OF_DAY: 'mailing.includeArticlesOfDay',
    NOT_SELECTED_CONTENT_SELECT_CONTENT_TO_CREATE: 'mailing.notSelectedContentSelectContentToCreate',
    ARE_YOU_SURE_YOU_WANT_TO_DELETE_CONTENT_FROM_NEWSLETTER_CONTENT_LIST:
      'mailing.areYouSureYouWantToDeleteContentFromNewsLetterContentList',
    ARE_YOU_SURE_YOU_WANT_TO_DELETE_CONTENT_FROM_PENDING_NEWSLETTER_LIST:
      'mailing.areYouSureYouWantToDeleteContentFromPendingNewsletterList',
    MAIL_GROUP_AND_TITLE: 'mailing.mailGroupAndTitle',
    MORNING_NOTES: 'mailing.morningNotes',
    "WHAT_SHOULD_WE_WATCH": 'mailing.whatShouldWeWatch',
    SUNDAY_SUPPLEMENT: 'mailing.sundaySupplement',
    BOOK_SUPPLEMENT: 'mailing.bookSupplement',
    CAMPAIGN_SITE_MISMATCH: 'mailing.campaignSiteMismatch'
  },
  story: {
    STORY: 'story.story',
    STORY_OLD: 'story.storyOld',
    STORY_AD: 'story.storyAd',
    STORY_LIST: 'story.storyList',
    EDIT_STORY: 'story.editStory',
    DELETE_STORY: 'story.deleteStory',
    STORY_DELETED: 'story.storyDeleted',
    ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_STORY: 'story.areYouSureYouWantToDeleteThisStory',
    ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_STORY_CONTENT: 'story.areYouSureYouWantToDeleteThisStoryContent',
    DELETE_STORY_CONTENT: 'story.deleteStoryContent',
    STORY_DETAIL: 'story.storyDetail',
    NOT_PUBLISHED: 'story.notPublished',
    STORY_COUNT: 'story.storyCount',
    EMPTY_STORY_AVAILABLE: 'story.emptyStoryAvailable',
    NO_STORY_AVAILABLE: 'story.noStoryAvailable',
    EMPTY_STORY_AVAILABLE_ADD_A_CONTENT_TO_SAVE: 'story.emptyStoryAvailableAddAContentToSave',
    AN_ERROR_OCCURRED_WHILE_SAVING_STORY: 'story.anErrorOccurredWhileSavingStory',
    STORY_ADDED: 'story.storyAdded',
    STORY_UPDATED: 'story.storyUpdated',
    YOU_NEED_TO_ENTER_VALID_URL_TO_SAVE: 'story.youNeedToEnterValidUrlToSave',
    YOU_NEED_TO_ENTER_A_TEXT_TO_SAVE: 'story.youNeedToEnterATextToSave',
    STORY_MANAGEMENT: 'story.storyManagement',
    PENDING_STORY_LIST: 'story.pendingStoryList',
    UPLOAD_STORY: 'story.uploadStory',
    ADD_STORY: 'story.addStory',
    PIN_STORY: 'story.pinStory',
    UNPIN_STORY: 'story.unpinStory',
    RESET_FILTERS_TO_CHANGE_STORY_PIN_STATUS: 'story.resetFiltersToChangeStoryPinStatus',
    AN_ERROR_OCCURRED_WHILE_PINNING_STORY: 'story.anErrorOccurredWhilePinningStory',
    STORY_PINNED: 'story.storyPinned',
    STORY_PINNING_REMOVED: 'story.storyPinningRemoved',
    STORY_ORDER: 'story.storyOrder',
    STORY_ORDER_UPDATED: 'story.storyOrderUpdated',
    AN_ERROR_OCCURRED_WHILE_UPDATING_STORY_ORDER: 'story.anErrorOccurredWhileUpdatingStoryOrder',
    STORY_TYPE: 'story.storyType',
    STORY_TYPE_NORMAL: 'story.storyTypeNormal',
    SHORT_STORY_TYPE_NORMAL: 'story.shortStoryTypeNormal',
    STORY_TYPE_ADVERTISEMENT: 'story.storyTypeAdvertisement',
    SHORT_STORY_TYPE_ADVERTISEMENT: 'story.shortStoryTypeAdvertisement',
    YOU_CAN_SET_STORY_ORDER_FOR_SELECTED_CATEGORIES: 'story.youCanSetStoryOrderForSelectedCategories',
    AT_LEAST_ONE_STORY_MUST_BE_ADDED_FOR_COMPLETING_THE_REGISTRATION: 'story.atLeastOneStoryMustBeAddedForCompletingTheRegistration',
    THIS_STORY_WILL_BE_ADDED_TO_THE_LIST_OF_PENDING_STORIES: 'story.thisStoryWillBeAddedToListOfPendingStories',
    THIS_STORY_WILL_BE_PUBLISHED_AT: 'story.thisStoryWillBePublishedAt',
    YOU_HAVE_UPDATED_THE_STORY_PUBLISH_DATE_DO_YOU_CONFIRM: 'story.youHaveUpdatedTheStoryPublishDateDoYouConfirm',
    THIS_STORY_REMOVED_FROM_THE_LIST_TO_BE_ADDED_TO_STORY_LIST_DO_YOU_CONFIRM:
      'story.thisStoryRemovedFormTheListTobeAddedStoryListDoYouConfirm',
    RELATED_CONTENT_ADDED_TO_THIS_STORY_WARNING: 'story.relatedContentAddedToThisStoryWarning',
    CHANGE_PINNING_STATUS_OF_STORY_NEED_TO_FILTER_CONTENT: 'story.changePinningStatusOfStoryNeedToFilterContent',
  },
  storyAd: {
    EDIT_STORY_AD: 'storyAd.editStoryAd',
    ADD_STORY_AD: 'storyAd.addStoryAd',
    ARE_YOU_SURE_YOU_WANT_TO_SAVE_WITHOUT_CATEGORY: 'storyAd.areYouSureYouWantToSaveWithoutCategory',
  },
  contentTransform: {
    CONTENT_PROVIDER_NOT_FOUND: 'contentTransform.contentProviderNotFound',
    CONTENT_TRANSFORMER_NOT_FOUND: 'contentTransform.contentTransformerNotFound',
    SELECTED_ITEM_FOUND: 'contentTransform.selectedItemFound',
    SELECTED_CONTENTS_WILL_BE_LOST: 'contentTransform.selectedContentsWillBeLost',
    EDITED_ITEM_FOUND: 'contentTransform.editedItemFound',
    EDITED_CONTENTS_WILL_BE_LOST: 'contentTransform.editedContentsWillBeLost',
  },
  htmlEditor: {
    plugins: {
      ADD_TABLE: 'htmlEditor.plugins.addTable',
      DELETE_TABLE: 'htmlEditor.plugins.deleteTable',
      ADD_LINK: 'htmlEditor.plugins.addLink',
      ADD_MULTIPLE_LINKS: 'htmlEditor.plugins.addMultipleLinks',
      UNDO: 'htmlEditor.plugins.undo',
      REDO: 'htmlEditor.plugins.redo',
      ADD_DIVIDER: 'htmlEditor.plugins.addDivider',
      ADD_BUTTON: 'htmlEditor.plugins.addButton',
    },
    toolbar: {
      TEXT_SIZE: 'htmlEditor.toolbar.textSize',
      SUBSCRIPT: 'htmlEditor.toolbar.subscript',
      SUPERSCRIPT: 'htmlEditor.toolbar.superscript',
      BOLD: 'htmlEditor.toolbar.bold',
      ITALIC: 'htmlEditor.toolbar.italic',
      STRIKETHROUGH: 'htmlEditor.toolbar.strikethrough',
      UNDERLINED: 'htmlEditor.toolbar.underlined',
      H1: 'htmlEditor.toolbar.h1',
      H2: 'htmlEditor.toolbar.h2',
      HEADING_TYPE: 'htmlEditor.toolbar.headingType',
      CODE_BLOCK: 'htmlEditor.toolbar.codeBlock',
      BLOCKQUOTE: 'htmlEditor.toolbar.blockquote',
      BLOCKQUOTE_AUTHOR: 'htmlEditor.toolbar.blockquoteAuthor',
      ADD_BLOCKQUOTE: 'htmlEditor.toolbar.addBlockquote',
      BLOCKQUOTE_DOUBLE: 'htmlEditor.toolbar.blockquoteDouble',
      BLOCKQUTE_BOLD: 'htmlEditor.toolbar.blockquoteBold',
      BLOCKQUOTE_NORMAL: 'htmlEditor.toolbar.blockquoteNormal',
      BLOCKQUOTE_FILL: 'htmlEditor.toolbar.pleaseFillBlockquoteArea',
      ALIGN: 'htmlEditor.toolbar.align',
      DIRECTION: 'htmlEditor.toolbar.direction',
      TEXT_COLOR: 'htmlEditor.toolbar.textColor',
      BACKGROUND_COLOR: 'htmlEditor.toolbar.backgroundColor',
      INDENT: 'htmlEditor.toolbar.indent',
      OUTDENT: 'htmlEditor.toolbar.outdent',
      ORDERED_LIST: 'htmlEditor.toolbar.orderedList',
      BULLET_LIST: 'htmlEditor.toolbar.bulletList',
      ADD_LINK: 'htmlEditor.toolbar.addLink',
      EMOJI: 'htmlEditor.toolbar.emoji',
      CLEAR_FORMATTING: 'htmlEditor.toolbar.clearFormatting',
      FULLSCREEN: 'htmlEditor.toolbar.fullscreen',
      EXIT_FULLSCREEN: 'htmlEditor.toolbar.exitFullscreen',
      UNDO: 'htmlEditor.toolbar.undo',
      REDO: 'htmlEditor.toolbar.redo',
      ADD_DIVIDER: 'htmlEditor.toolbar.addDivider',
    },
    addTable: {
      ROWS: 'htmlEditor.addTable.rows',
      COLUMNS: 'htmlEditor.addTable.columns',
    },
    addLink: {
      TEXT: 'htmlEditor.addLink.text',
      LINK: 'htmlEditor.addLink.link',
      PLAIN_LINK: 'htmlEditor.addLink.plainLink',
    },
    addMultipleLinks: {
      TEXT: 'htmlEditor.addMultipleLinks.text',
      HREF: 'htmlEditor.addMultipleLinks.href',
    },
    addDivider: {
      COLOR: 'htmlEditor.addDivider.color',
      CUSTOM_COLOR: 'htmlEditor.addDivider.customColor',
    },
    addButton: {
      ICON: 'htmlEditor.addButton.icon',
      LABEL: 'htmlEditor.addButton.label',
      LINK: 'htmlEditor.addButton.link',
      BACKGROUND_COLOR: 'htmlEditor.addButton.backgroundColor',
      TEXT_COLOR: 'htmlEditor.addButton.textColor',
    },
  },
  agency: {
    AGENCY_MANAGEMENT: 'agency.agencyManagement',
    AGENCY: 'agency.agency',
    PHOTO: 'agency.photo',
    PHOTO_MENU: 'agency.photo_menu',
    INFOGRAPHIC: 'agency.infographic',
    INFOGRAPHIC_MENU: 'agency.infographic_menu',
    ARCHIVE: 'agency.archive',
    QUICK_VIEW: 'agency.quickView',
    CREATE_CONTENT_PAGE: 'agency.createContentPage',
    CREATE_NEWS_PAGE: 'agency.createNewsPage',
    CREATE_VIDEO_PAGE: 'agency.createVideoPage',
    CREATE_PHOTO_GALLERY_PAGE: 'agency.createPhotoGalleryPage',
    APPROVED_ARCHIVE: 'agency.approvedArchive',
    UNAPPROVED_ARCHIVE: 'agency.unapprovedArchive',
    ADD_ARCHIVE: 'agency.addArchive',
    EDIT_ARCHIVE: 'agency.editArchive',
    ARCHIVE_CONTENT: 'agency.archiveContent',
    ARCHIVE_PHOTO: 'agency.archivePhoto',
    SHOW_NEWS_DETAIL: 'agency.showNewsDetail',
    AGENCY_NEWS_DETAIL: 'agency.agencyNewsDetail',
    VIEW_AGENCY_NEWS_DETAIL: 'agency.viewAgencyNewsDetail',
    A_DRAFT_RECORD_FOR_AGENCY_CONTENT_WILL_BE_CREATED_ARE_YOU_SURE: 'agency.aDraftRecordForAgencyContentWillBeCreatedAreYouSure',
    SELECT_THE_PHOTOS_YOU_WANT_TO_UPLOAD: 'agency.selectThePhotosYouWantToUpload',
    SELECT_THE_CONTENT_TYPE_YOU_WANT_TO_CREATE: 'agency.selectTheContentTypeYouWantToCreate',
    ADD_VIDEO_PROVIDED_BY_AGENCY_TO_VIDEO_CONTENT_TO_BE_CREATED: 'agency.addVideoProvidedByAgencyToVideoContentToBeCreated',
    UPLOAD_AND_CONTINUE: 'agency.uploadAndContinue',
    DOWNLOAD_PICTURES: 'agency.downloadPictures',
    DOWNLOAD_AI: 'agency.downloadAi',
    CREATE_ARCHIVE_CONTENT: 'agency.createArchiveContent',
    ARE_YOU_SURE_YOU_WANT_TO_SAVE_THE_AGENCY_CONTENT_TO_THE_ARCHIVE:
      'agency.areYouSureYouWantToSaveTheAgencyContentToTheArchive',
    TO_CREATE_A_PHOTO_GALLERY_AT_LEAST_TWO_IMAGES_MUST_BE_SELECTED: 'agency.toCreateAPhotoGalleryAtLeastTwoImagesMustBeSelected',
    TO_CREATE_A_INFOGRAPHIC_AT_LEAST_ONE_IMAGES_MUST_BE_SELECTED: 'agency.toCreateAInfographicAtLeastTwoImagesMustBeSelected',
    TO_CREATE_A_ARCHIVE_AT_LEAST_ONE_IMAGES_MUST_BE_SELECTED: 'agency.toCreateAArchiveAtLeastOneImagesMustBeSelected',
    THE_CONTENT_COULD_NOT_BE_ADDED_BECAUSE_THE_SOURCE_COULD_NOT_BE_FOUND: 'agency.theContentCouldNotBeAddedBecauseTheSourceCouldNotBeFound',
    A_CONTENT_HAS_ALREADY_BEEN_CREATED_USING_THIS_AGENCY_CONTENT: 'agency.aContentHasAlreadyBeenCreatedUsingThisAgencyContent',
    A_CONTENT_HAS_ALREADY_BEEN_CREATED_USING_THIS_ARCHIVE_CONTENT: 'agency.aContentHasAlreadyBeenCreatedUsingThisArchiveContent',
    A_CONTENT_HAS_ALREADY_BEEN_CREATE_WITH_THE_PHOTO_GALLERY_CONTENT_FROM_ARCHIVE:
      'agency.aContentHasAlreadyBeenCreatedWithThePhotoGalleryContentFromWhichThisArchiveContentWasCreated',
    IMAGE_DESCRIPTION_NOT_AVAILABLE: 'agency.imageDescriptionNotAvailable',
    SELECT_THE_IMAGES_YOU_WANT_TO_BRING_FROM_THE_ARCHIVE: 'agency.selectTheImagesYouWantToBringFromTheArchive',
    SELECT_THE_IMAGES_YOU_WANT_TO_BRING_FROM_THE_AGENCY: 'agency.selectTheImagesYouWantToBringFromTheAgency',
    ADD_PHOTO_DESCRIPTIONS: 'agency.addPhotoDescriptions',
    AN_UPDATE_HAS_BEEN_MADE_ON_THE_NEWS_CLICK_FOR_OTHER_UPDATES: 'agency.anUpdateHasBeenMadeOnTheNewsClickForOtherUpdates',
    INAPPROPRIATE_CONTENT: 'agency.inappropriateContent',
    USED_CONTENT: 'agency.usedContent',
    MARK_AS_INAPPROPRIATE: 'agency.markAsInappropriate',
    MARK_AS_APPROPRIATE: 'agency.markAsAppropriate',
    MARK_AS_USED: 'agency.markAsUsed',
    MARK_AS_UNUSED: 'agency.markAsUnused',
    ADD_PHOTO_INFORMATION: 'agency.addPhotoInformation',
    SELECT_ALL: 'agency.selectAll',
    SELECT_THE_PHOTOS_YOU_WANT_TO_DOWNLOAD: 'agency.selectThePhotosYouWantToDownload',
    ARCHIVE_MANAGEMENT: 'agency.archiveManagement',
    ARCHIVE_CONTENT_TAGS: 'agency.archiveContentTags',
    REMOVE_SELECTIONS: 'agency.removeSelections',
    NEW_CONTENT_AVAILABLE: 'agency.newContentAvailable',
    GENERATE_AI_CONTENT: 'agency.generateAiContent',
    CREATED_CONTENTS: 'agency.createdContents',
    AI_CONTENT_QUEUE_CONFIRM: 'agency.aiContentQueueConfirm',
    AI_CONTENT_QUEUE_SUCCESS: 'agency.aiContentQueueSuccess',
    DELETE_ARCHIVE: 'agency.deleteArchive',
    ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_ARCHIVE: 'agency.areYouSureYouWantToDeleteThisArchive',
    ARCHIVE_DELETED_SUCCESSFULLY: 'agency.archiveDeletedSuccessfully',
    ARCHIVE_COULD_NOT_BE_DELETED: 'agency.archiveCouldNotBeDeleted',
  },
  aiContent: {
    AI_CONTENTS: 'aiContent.aiContents',
    PENDING_REVIEW: 'aiContent.pendingReview',
    PROCESSING: 'aiContent.processing',
    APPROVED: 'aiContent.approved',
    DENIED: 'aiContent.denied',
    FAILED: 'aiContent.failed',
    APPROVE: 'aiContent.approve',
    DENY: 'aiContent.deny',
    RETRY: 'aiContent.retry',
    AI_GENERATED_BANNER: 'aiContent.aiGeneratedBanner',
    NO_PENDING_ITEMS: 'aiContent.noPendingItems',
    AGENCY_SOURCE: 'aiContent.agencySource',
    TITLE: 'aiContent.title',
    STATUS: 'aiContent.status',
    CONTENT_TYPE: 'aiContent.contentType',
    DATE: 'aiContent.date',
    CREATED_BY: 'aiContent.createdBy',
    EDIT: 'aiContent.edit',
    RETRY_NOTES: 'aiContent.retryNotes',
    REGENERATE: 'aiContent.regenerate',
    VERSION_HISTORY: 'aiContent.versionHistory',
    RESTORE_VERSION: 'aiContent.restoreVersion',
    CURRENT_VERSION: 'aiContent.currentVersion',
    ALREADY_BEING_REVIEWED: 'aiContent.alreadyBeingReviewed',
    CLAIM_LOST: 'aiContent.claimLost',
    CLAIM_LOST_DURING_APPROVE: 'aiContent.claimLostDuringApprove',
    CLAIM_LOST_DURING_DENY: 'aiContent.claimLostDuringDeny',
    ALREADY_APPROVED_BY_OTHER: 'aiContent.alreadyApprovedByOther',
    YOU_ARE_REVIEWING: 'aiContent.youAreReviewing',
    MINUTES_REMAINING: 'aiContent.minutesRemaining',
    POSSIBLY_STUCK: 'aiContent.possiblyStuck',
    NO_HEARTBEAT_FOR: 'aiContent.noHeartbeatFor',
    WHY_FAILED: 'aiContent.whyFailed',
    PHASE_ACQUIRING: 'aiContent.phaseAcquiring',
    PHASE_FETCHING_CONTENT: 'aiContent.phaseFetchingContent',
    PHASE_CLASSIFYING_CATEGORIES: 'aiContent.phaseClassifyingCategories',
    PHASE_CALLING_AI_SERVICE: 'aiContent.phaseCallingAiService',
    PHASE_MATCHING_CATEGORIES: 'aiContent.phaseMatchingCategories',
    PHASE_SAVING_RESULT: 'aiContent.phaseSavingResult',
    PHASE_FINALIZING: 'aiContent.phaseFinalizing',
    CATEGORY_CANDIDATES_TITLE: 'aiContent.categoryCandidatesTitle',
    CATEGORY_CANDIDATES_EMPTY: 'aiContent.categoryCandidatesEmpty',
    CATEGORY_POOL: {
      TOPICAL: 'aiContent.categoryPool.topical',
      GEOGRAPHIC: 'aiContent.categoryPool.geographic',
      EVENT: 'aiContent.categoryPool.event',
    },
    FAILURE_DETAILS: {
      TITLE: 'aiContent.failureDetails.title',
      SUMMARY: {
        CONTENT_FILTER: 'aiContent.failureDetails.summary.content_filter',
        PROMPT_FILTER: 'aiContent.failureDetails.summary.prompt_filter',
        PARSE_ERROR: 'aiContent.failureDetails.summary.parse_error',
        TIMEOUT: 'aiContent.failureDetails.summary.timeout',
        RATE_LIMIT: 'aiContent.failureDetails.summary.rate_limit',
        INTERNAL_ERROR: 'aiContent.failureDetails.summary.internal_error',
        UNKNOWN: 'aiContent.failureDetails.summary.unknown',
      },
      SECTION_PILL: {
        INPUT: 'aiContent.failureDetails.sectionPill.input',
        OUTPUT: 'aiContent.failureDetails.sectionPill.output',
      },
      CATEGORY_COLUMN: 'aiContent.failureDetails.categoryColumn',
      SEVERITY_COLUMN: 'aiContent.failureDetails.severityColumn',
      BLOCKED_COLUMN: 'aiContent.failureDetails.blockedColumn',
      SOURCE_COLUMN: 'aiContent.failureDetails.sourceColumn',
      BLOCKED_YES: 'aiContent.failureDetails.blockedYes',
      BLOCKED_NO: 'aiContent.failureDetails.blockedNo',
      ERROR_CODE_LABEL: 'aiContent.failureDetails.errorCodeLabel',
      HTTP_STATUS_LABEL: 'aiContent.failureDetails.httpStatusLabel',
      FINISH_REASON_LABEL: 'aiContent.failureDetails.finishReasonLabel',
      OCCURRED_AT_LABEL: 'aiContent.failureDetails.occurredAtLabel',
      PARTIAL_OUTPUT_HEADING: 'aiContent.failureDetails.partialOutputHeading',
      PARTIAL_OUTPUT_EMPTY: 'aiContent.failureDetails.partialOutputEmpty',
      RAW_RESPONSE_HEADING: 'aiContent.failureDetails.rawResponseHeading',
      COPY_TO_CLIPBOARD: 'aiContent.failureDetails.copyToClipboard',
      COPIED: 'aiContent.failureDetails.copied',
      NO_DETAILS_AVAILABLE: 'aiContent.failureDetails.noDetailsAvailable',
      CLOSE: 'aiContent.failureDetails.close',
    },
  },
  agencyNewsType: {
    NEWS_TYPE_IMPORTANT_DEVELOPMENT: 'agencyNewsType.newsTypeImportantDevelopment',
    NEWS_TYPE_FLASH_DEVELOPMENT: 'agencyNewsType.newsTypeFlashDevelopment',
    NEWS_TYPE_HOT_DEVELOPMENT: 'agencyNewsType.newsTypeHotDevelopment',
    NEWS_TYPE_STANDARD_DEVELOPMENT: 'agencyNewsType.newsTypeStandardDevelopment',
  },
  liveTransfer: {
    LIVE_TRANSFER: 'liveTransfer.liveTransfer',
    LIVE_TRANSFER_LIST: 'liveTransfer.liveTransferList',
    ADD_LIVE_TRANSFER: 'liveTransfer.addNewLiveTransfer',
    LINK_NAME: 'liveTransfer.linkName',
    OFFICIAL: 'liveTransfer.official',
    UNOFFICIAL: 'liveTransfer.unofficial',
  },
  videoProcessQueue: {
    FILE_NAME: 'videoProcessQueue.fileName',
    CREATED_AT: 'videoProcessQueue.createdAt',
    FILE_SIZE: 'videoProcessQueue.fileSize',
    STATUS: 'videoProcessQueue.status',
    RESOLUTIONS: 'videoProcessQueue.resolutions',
    PROCESS_START_TIME: 'videoProcessQueue.processStartTime',
    PROCESS_END_TIME: 'videoProcessQueue.processEndTime',
    PROCESS_DURATION: 'videoProcessQueue.processDuration',
    WAITING: 'videoProcessQueue.waiting',
    IN_PROGRESS: 'videoProcessQueue.inProgress',
    FINISHED: 'videoProcessQueue.finished',
    ERROR: 'videoProcessQueue.error',
    VIDEO_PROCESS_QUEUE: 'videoProcessQueue.videoProcessQueue',
    FETCH_ERROR: 'videoProcessQueue.fetchError',
  },
  dashboard: {
    DASHBOARD: 'dashboard.dashboard',
    EDITOR: 'dashboard.editor',
    EDITOR_PERFORMANCE: 'dashboard.editorPerformance',
    SEARCH_EDITOR: 'dashboard.searchEditor',
    DATE_FILTER: 'dashboard.dateFilter',
    DATE_RANGE_FILTER: 'dashboard.dateRangeFilter',
    PREVIOUS_CONTENT_COUNT: 'dashboard.previousContentCount',
    CURRENT_CONTENT_COUNT: 'dashboard.currentContentCount',
    PREVIOUS_VIEW_COUNT: 'dashboard.previousViewCount',
    CURRENT_VIEW_COUNT: 'dashboard.currentViewCount',
    EARLIER_DAY_CONTENT_COUNT: 'dashboard.earlierDayContentCount',
    SELECTED_DAY_CONTENT_COUNT: 'dashboard.selectedDayContentCount',
    EARLIER_DAY_VIEW_COUNT: 'dashboard.earlierDayViewCount',
    SELECTED_DAY_VIEW_COUNT: 'dashboard.selectedDayViewCount',
    COMPARED_TO_EARLIER_DAY: 'dashboard.comparedToEarlierDay',
    COMPARISON_RANGE: 'dashboard.comparisonRange',
    TOTAL: 'dashboard.total',
    ANALYTICS_FAILED: 'dashboard.analyticsFailed',
    ANALYTICS_FAILED_TEMPORARILY: 'dashboard.analyticsFailedTemporarily',
    ENTERED_BY_EDITOR_INFO: 'dashboard.enteredByEditorInfo',
    SITE_TOTAL_TRAFFIC: 'dashboard.siteTotalTraffic',
    SITE_TOTAL_TRAFFIC_INFO: 'dashboard.siteTotalTrafficInfo',
    TRAFFIC_BY_PAGE_GROUP: 'dashboard.trafficByPageGroup',
    TRAFFIC_BY_PAGE_GROUP_INFO: 'dashboard.trafficByPageGroupInfo',
    SITE_TRAFFIC_CONTENT_SHARE: 'dashboard.siteTrafficContentShare',
    CONTENT_COUNT_INFO: 'dashboard.contentCountInfo',
    VIEW_COUNT_INFO: 'dashboard.viewCountInfo',
    VIEW_COUNT_CAPPED_INFO: 'dashboard.viewCountCappedInfo',
    ATTRIBUTION_NOTICE: 'dashboard.attributionNotice',
    ATTRIBUTION_NOTICE_CAPPED: 'dashboard.attributionNoticeCapped',
    DETAIL_RANGE_INFO: 'dashboard.detailRangeInfo',
    DETAIL_CONTENT_COUNT_INFO: 'dashboard.detailContentCountInfo',
    DETAIL_AVERAGE_INFO: 'dashboard.detailAverageInfo',
    CHART_SCOPE_INFO: 'dashboard.chartScopeInfo',
    AVERAGE_SHORT: 'dashboard.averageShort',
    TABLE_HELP_EDITOR: 'dashboard.tableHelpEditor',
    TABLE_HELP_CONTENT: 'dashboard.tableHelpContent',
    TABLE_HELP_VIEWS: 'dashboard.tableHelpViews',
    TABLE_HELP_AVERAGE: 'dashboard.tableHelpAverage',
    TABLE_HELP_SORT: 'dashboard.tableHelpSort',
    CHART_HELP_DUAL: 'dashboard.chartHelpDual',
    CHART_HELP_VIEWS: 'dashboard.chartHelpViews',
    CHART_HELP_AVERAGE: 'dashboard.chartHelpAverage',
    CHART_HELP_TOOLTIP: 'dashboard.chartHelpTooltip',
    MOST_READ_SCOPE_INFO: 'dashboard.mostReadScopeInfo',
    DETAIL: 'dashboard.detail',
    GROUP_HOME: 'dashboard.groupHome',
    GROUP_NEWS: 'dashboard.groupNews',
    GROUP_GALLERY: 'dashboard.groupGallery',
    GROUP_VIDEO: 'dashboard.groupVideo',
    GROUP_COLUMN: 'dashboard.groupColumn',
    GROUP_REEL: 'dashboard.groupReel',
    GROUP_EMBED: 'dashboard.groupEmbed',
    GROUP_LISTING: 'dashboard.groupListing',
    GROUP_OTHER_CONTENT: 'dashboard.groupOtherContent',
    GROUP_OTHER: 'dashboard.groupOther',
    PAGE_BREAKDOWN: 'dashboard.pageBreakdown',
    CONTENT_COUNT: 'dashboard.contentCount',
    VIEW_COUNT: 'dashboard.viewCount',
    AVERAGE_VIEW_COUNT: 'dashboard.averageViewCount',
    TOTAL_CONTENT_COUNT: 'dashboard.totalContentCount',
    TOTAL_VIEW_COUNT: 'dashboard.totalViewCount',
    PERFORMANCE_CHART: 'dashboard.performanceChart',
    CHART_TAB_DUAL: 'dashboard.chartTabDual',
    CHART_TAB_CONTENT_COUNT: 'dashboard.chartTabContentCount',
    CHART_TAB_VIEW_COUNT: 'dashboard.chartTabViewCount',
    CHART_TAB_AVERAGE_VIEW_COUNT: 'dashboard.chartTabAverageViewCount',
    MOST_READ_CONTENTS: 'dashboard.mostReadContents',
    CONTENT_TITLE: 'dashboard.contentTitle',
    BYLINE: 'dashboard.byline',
    CATEGORY: 'dashboard.category',
    PUBLISH_DATE: 'dashboard.publishDate',
    SHOW_ON_WEBSITE: 'dashboard.showOnWebsite',
    ANALYTICS_LAST_24_HOURS_WARNING: 'dashboard.analyticsLast24HoursWarning',
    ANALYTICS_NOT_CONFIGURED: 'dashboard.analyticsNotConfigured',
    FETCH_ERROR: 'dashboard.fetchError',
  },
  editorContentReport: {
    EDITOR_NAME: 'editorContentReport.editorName',
    CONTENT_COUNT: 'editorContentReport.contentCount',
    NEWS_WORTHY_CONTENT_COUNT: 'editorContentReport.newsWorthyContentCount',
    FETCH_ERROR: 'editorContentReport.fetchError',
    DOWNLOAD: 'editorContentReport.download',
    USERNAME: 'editorContentReport.username',
    TOTAL: 'editorContentReport.total',
    DAILY: 'editorContentReport.daily',
    MONTHLY: 'editorContentReport.monthly',
    CUSTOM_RANGE: 'editorContentReport.customRange',
    PREVIOUS_MONTH: 'editorContentReport.previousMonth',
    NEXT_MONTH: 'editorContentReport.nextMonth',
    SITE_TOTAL: 'editorContentReport.siteTotal',
    SITE_TOTAL_INFO: 'editorContentReport.siteTotalInfo',
  },
  reels: {
    REELS: 'reels.reels',
    REELS_MANAGEMENT: 'reels.reelsManagement',
    ADD_REELS: 'reels.addReels',
    REELS_LIST: 'reels.reelsList',
    PENDING_REELS_LIST: 'reels.pendingReelsList',
    EDIT_REELS: 'reels.editReels',
    REELS_ID: 'reels.reelsId',
    REELS_TYPE: 'reels.reelsType',
    REELS_TYPE_NORMAL: 'reels.reelsTypeNormal',
    REELS_ORDER: 'reels.reelsOrder',
    REELS_ORDER_UPDATED: 'reels.reelsOrderUpdated',
    AN_ERROR_OCCURRED_WHILE_UPDATING_REELS_ORDER: 'reels.anErrorOccurredWhileUpdatingReelsOrder',
    THIS_REELS_WILL_BE_PUBLISHED_AT: 'reels.thisReelsWillBePublishedAt',
    REELS_TYPE_ADVERTISEMENT: 'reels.reelsTypeAdvertisement',
    DELETE_REELS_CONTENT: 'reels.deleteReelsContent',
    ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_REELS_CONTENT: 'reels.areYouSureYouWantToDeleteThisReelsContent',
    RELATED_CONTENT_ADDED_TO_THIS_REELS_WARNING: 'reels.relatedContentAddedToThisReelsWarning',
    AT_LEAST_ONE_REELS_MUST_BE_ADDED_FOR_COMPLETING_THE_REGISTRATION: 'reels.atLeastOneReelsMustBeAddedForCompletingTheRegistration',
    RESET_FILTERS_TO_CHANGE_REEL_PIN_STATUS: 'reels.resetFiltersToChangeReelPinStatus',
    CHANGE_PINNING_STATUS_OF_REEL_NEED_TO_FILTER_CONTENT: 'reels.changePinningStatusOfReelNeedToFilterContent',
    AN_ERROR_OCCURRED_WHILE_PINNING_REEL: 'reels.anErrorOccurredWhilePinningReel',
    PIN_REELS: 'reels.pinReels',
    UNPIN_REELS: 'reels.unpinReels',
    REEL_PINNED: 'reels.reelPinned',
    REEL_PINNING_REMOVED: 'reels.reelPinningRemoved',
    REEL_ORDER_UPDATED: 'reels.reelOrderUpdated',
    YOU_CAN_SET_REEL_ORDER_FOR_SELECTED_CATEGORIES: 'reels.youCanSetReelOrderForSelectedCategories',
    AN_ERROR_OCCURRED_WHILE_UPDATING_REEL_ORDER: 'reels.anErrorOccurredWhileUpdatingReelOrder',
    THIS_REEL_WILL_BE_ADDED_TO_THE_LIST_OF_PENDING_REELS: 'reels.thisReelWillBeAddedToListOfPendingReels',
    YOU_HAVE_UPDATED_THE_REEL_PUBLISH_DATE_DO_YOU_CONFIRM: 'reels.youHaveUpdatedTheReelPublishDateDoYouConfirm',
    THIS_REEL_REMOVED_FROM_THE_LIST_TO_BE_ADDED_TO_REELS_LIST_DO_YOU_CONFIRM:
      'reels.thisReelRemovedFormTheListTobeAddedReelsListDoYouConfirm',
  },
  menu: {
    MENU: 'menu.menu',
    MENUS: 'menu.menus',
    MENU_MANAGEMENT: 'menu.menuManagement',
    MENU_MANAGEMENT_TITLE: 'menu.menuManagementTitle',
    MENU_NAME: 'menu.menuName',
    YOU_HAVE_UNSAVED_CHANGED_IN_THIS_MENU: 'menu.youHaveUnsavedChangesInThisMenu',
    AN_ERROR_OCCURRED_WHILE_SAVING_MENU: 'menu.anErrorOccurredWhileSavingMenu',
    MENU_SAVED: 'menu.menuSaved',
    ADD_ITEM_TO_MENU: 'menu.addItemToMenu',
    EDIT_MENU_ITEM: 'menu.editMenuItem',
    DELETE_MENU_ITEM: 'menu.deleteMenuItem',
    MENU_ITEM_DELETED: 'menu.menuItemDeleted',
    HIDE_GENERATED_ITEMS: 'menu.hideGeneratedItems',
    SHOW_GENERATED_ITEMS: 'menu.showGeneratedItems',
    CLEAR_MENU_CACHE: 'menu.clearMenuCache',
    THE_MENU_CACHE_WILL_BE_CLEARED_ARE_YOU_SURE: 'menu.theMenuCacheWillBeCleanedAreYouSure',
    MENU_CACHE_CLEARED: 'menu.menuCacheCleared',
    AN_ERROR_OCCURRED_WHILE_CLEARING_MENU_CACHE: 'menu.anErrorOccurredWhileClearingMenuCache',
    ITEM_TYPE: 'menu.itemType',
    POSITION_TO_BE_ADDED: 'menu.positionToBeAdded',
    ADD_TO_TOP: 'menu.addToTop',
    ADD_TO_END: 'menu.addToEnd',
    MENU_IMAGE: 'menu.menuImage',
    DIVIDER: 'menu.divider',
    MENU_IMAGE_DARK: 'menu.menuImageDark',
    SELECT_MENU_IMAGE: 'menu.selectMenuImage',
    CHANGE_MENU_IMAGE: 'menu.changeMenuImage',
    REMOVE_MENU_IMAGE: 'menu.removeMenuImage',
    SELECT_MENU_DARK_IMAGE: 'menu.selectMenuDarkImage',
    CHANGE_MENU_DARK_IMAGE: 'menu.changeMenuDarkImage',
    REMOVE_MENU_DARK_IMAGE: 'menu.removeMenuDarkImage',
    ARE_YOU_SURE_WANT_TO_DELETE_MENU_ITEM_IMAGE: 'menu.areYouSureWantToDeleteMenuItemImage',
    ADD_LINK_ITEM: 'menu.addLinkItem',
    EDIT_LINK_ITEM: 'menu.editLinkItem',
    ADD_CONTENT_TYPE_ITEM: 'menu.addContentTypeItem',
    EDIT_CONTENT_TYPE_ITEM: 'menu.editContentTypeItem',
    ADD_CATEGORY_ITEM: 'menu.addCategoryItem',
    EDIT_CATEGORY_ITEM: 'menu.editCategoryItem',
    ADD_BRAND_ITEM: 'menu.addBrandItem',
    EDIT_BRAND_ITEM: 'menu.editBrandItem',
    ADD_NEWSPAPER_AUTHOR_LIST_ITEM: 'menu.addNewspaperAuthorListItem',
    EDIT_NEWSPAPER_AUTHOR_LIST_ITEM: 'menu.editNewspaperAuthorListItem',
    ADD_SPORT_AUTHOR_LIST_ITEM: 'menu.addSportAuthorListItem',
    EDIT_SPORT_AUTHOR_LIST_ITEM: 'menu.editSportAuthorListItem',
    ADD_ARCHIVE_AUTHOR_LIST_ITEM: 'menu.addArchiveAuthorListItem',
    EDIT_ARCHIVE_AUTHOR_LIST_ITEM: 'menu.editArchiveAuthorListItem',
    ADD_AUTHOR_LIST_ITEM: 'menu.addAuthorListItem',
    EDIT_AUTHOR_LIST_ITEM: 'menu.editAuthorListItem',
    ADD_CARTOONIST_LIST_ITEM: 'menu.addCartoonistListItem',
    EDIT_CARTOONIST_LIST_ITEM: 'menu.editCartoonistListItem',
    LINK_NAME: 'menu.linkName',
    SPECIAL_IMAGE: 'menu.specialImage',
    BRAND_MENU: 'menu.brandMenu',
    SUB_CATEGORY_DEPTH: 'menu.subCategoryDepth',
    EXCLUDED_CATEGORIES: 'menu.excludedCategories',
    YOUR_MENU_ITEM_TO_ADD_UNAPPROVED: 'menu.yourMenuItemToAddUnapproved',
    THE_UPDATED_VERSION_OF_THE_SUB_CATEGORY_LIST_WILL_BE_DISPLAYED_AFTER_SAVING:
      'menu.theUpdatedVersionOfTheSubCategoryListWillBeDisplayedAfterSaving',
    THE_DETAILS_OF_THE_AUTHOR_LIST_WILL_BE_DISPLAYED_AFTER_SAVING:
      'menu.theDetailsOfTheAuthorListWillBeDisplayedAfterSaving',
    THE_DETAILS_OF_THE_CARTOONIST_LIST_WILL_BE_DISPLAYED_AFTER_SAVING:
      'menu.theDetailsOfTheCartoonistListWillBeDisplayedAfterSaving',
  },
  color: {
    RED: 'color.red',
    GREEN: 'color.green',
    BLUE: 'color.blue',
    LIGHT_BROWN: 'color.lightBrown',
    PURPLE: 'color.purple',
    YELLOW: 'color.yellow',
  },
  seo: {
    SEO: 'seo.seo',
    SEO_LIST: 'seo.seoList',
    SEO_ID: 'seo.seoId',
    ADD_SEO: 'seo.addSeo',
    EDIT_SEO: 'seo.editSeo',
    URL: 'seo.url',
    URI: 'seo.uri',
    TITLE: 'seo.title',
    KEYWORDS: 'seo.keywords',
    KEYWORDS_HINT: 'seo.keywordsHint',
    DESCRIPTION: 'seo.description',
    SEARCH_SEO: 'seo.searchSeo',
    feedback: {
      OK: 'seo.feedback.ok',
      SHORT: 'seo.feedback.short',
      LONG: 'seo.feedback.long',
      CHARACTER: 'seo.feedback.character',
      HINT: 'seo.feedback.hint'
    },
  },
  error: {
    404: 'app.error',
    unauthorized: 'auth.noAuthorization',
    unauthenticated: 'auth.noAuthorization',
  },
  newspaperHeadline: {
    TITLE: 'newspaperHeadline.title',
    PREV_DAY: 'newspaperHeadline.prevDay',
    NEXT_DAY: 'newspaperHeadline.nextDay',
    NO_NEWSPAPERS: 'newspaperHeadline.noNewspapers',
    UNKNOWN_NEWSPAPER: 'newspaperHeadline.unknownNewspaper',
    BACK: 'newspaperHeadline.back',
    PAGE: 'newspaperHeadline.page',
    NO_PAGES: 'newspaperHeadline.noPages',
  },
  dailyMenu: {
    TITLE: 'dailyMenu.title',
    PUBLISH_DATE: 'dailyMenu.publishDate',
    PUBLISH_DATE_REQUIRED: 'dailyMenu.publishDateRequired',
    PUBLISH_DATE_ALREADY_USED: 'dailyMenu.publishDateAlreadyUsed',
    NO_RECIPE_SELECTED_IN_ANY_GROUP: 'dailyMenu.noRecipeSelectedInAnyGroup',
    ADD_RECIPE: 'dailyMenu.addRecipe',
    SEARCH_TO_LIST_RECIPES: 'dailyMenu.searchToListRecipes',
    NO_RECIPE_IN_GROUP: 'dailyMenu.noRecipeInGroup',
    MAIN_RECIPE: 'dailyMenu.mainRecipe',
    ALTERNATIVE_RECIPE: 'dailyMenu.alternativeRecipe',
    FIRST_RECIPE_IS_MAIN_HINT: 'dailyMenu.firstRecipeIsMainHint',
    RECIPE_COUNT: 'dailyMenu.recipeCount',
    GROUP_RECIPE_LIMIT_REACHED: 'dailyMenu.groupRecipeLimitReached',
    GROUP_RECIPE_LIMIT_HINT: 'dailyMenu.groupRecipeLimitHint',
    REMOVE_RECIPE: 'dailyMenu.removeRecipe',
    DELETE_MENU: 'dailyMenu.deleteMenu',
    ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_MENU: 'dailyMenu.areYouSureYouWantToDeleteThisMenu',
    DELETED_SUCCESSFULLY: 'dailyMenu.deletedSuccessfully',
    DELETE_FAILED: 'dailyMenu.deleteFailed',
    GROUP_SOUPS: 'dailyMenu.groupSoups',
    GROUP_MAIN_DISHES: 'dailyMenu.groupMainDishes',
    GROUP_SALADS: 'dailyMenu.groupSalads',
    GROUP_DESSERTS: 'dailyMenu.groupDesserts',
    GROUP_SNACKS: 'dailyMenu.groupSnacks',
    GROUP_DRINKS: 'dailyMenu.groupDrinks',
  },
  mailingCategory: {
    MAILING_CATEGORIES: 'mailingCategory.mailingCategories',
    ADD_MAILING_CATEGORY: 'mailingCategory.addMailingCategory',
    EDIT_MAILING_CATEGORY: 'mailingCategory.editMailingCategory',
    LOGO: 'mailingCategory.logo',
    SELECT_LOGO: 'mailingCategory.selectLogo',
    CHANGE_LOGO: 'mailingCategory.changeLogo',
    UPLOAD_DARK_LOGO: 'mailingCategory.uploadDarkLogo',
    SELECT_DARK_LOGO: 'mailingCategory.selectDarkLogo',
    CHANGE_DARK_LOGO: 'mailingCategory.changeDarkLogo',
    DESCRIPTION: 'mailingCategory.description',
    FREQUENCY: 'mailingCategory.frequency',
    FREQUENCY_DAILY: 'mailingCategory.frequencyDaily',
    FREQUENCY_WEEKLY: 'mailingCategory.frequencyWeekly',
    FREQUENCY_MONTHLY: 'mailingCategory.frequencyMonthly',
    FREQUENCY_QUARTERLY: 'mailingCategory.frequencyQuarterly',
    FREQUENCY_AS_NEEDED: 'mailingCategory.frequencyAsNeeded',
    MAILING_CAMPAIGN_ID: 'mailingCategory.mailingCampaignId',
    CHANNEL_NAME: 'mailingCategory.channelName',
    WIDGETS: 'mailingCategory.widgets',
    DELETE_MAILING_CATEGORY: 'mailingCategory.deleteMailingCategory',
    ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_MAILING_CATEGORY: 'mailingCategory.areYouSureYouWantToDeleteThisMailingCategory',
    ORDER_UPDATED: 'mailingCategory.orderUpdated',
  },
  router: {
    dashboard: 'router.dashboard',
    'dashboard-overview': 'router.dashboardOverview',
    'dashboard-editor-detail': 'router.dashboardEditorDetail',
    agency: 'router.agency',
    'agency-list': 'router.agencyList',
    archive: 'router.archive',
    'archive-list': 'router.archiveList',
    'comments-list': 'router.commentsList',
    content: 'router.content',
    'content-list': 'router.contentList',
    'content-list-draft': 'router.contentListDraft',
    news: 'router.news',
    video: 'router.video',
    'photo-gallery': 'router.photoGallery',
    column: 'router.column',
    cartoon: 'router.cartoon',
    infographic: 'router.infographic',
    promotion: 'router.promotion',
    podcast: 'router.podcast',
    'official-announcement': 'router.officialAnnouncement',
    newspaper: 'router.newspaper',
    'newspaper-headline': 'router.newspaperHeadline',
    'newspaper-headline-list': 'router.newspaperHeadline',
    'newspaper-headline-detail': 'router.newspaperHeadlineDetail',
    notifications: 'router.notifications',
    'recipe-notifications': 'router.recipeNotifications',
    'recipe-daily-menu': 'router.recipeDailyMenu',
    'live-transfers': 'router.liveTransfers',
    'video-process-queue': 'router.video-process-queue',
    'editor-content-report': 'router.editor-content-report',
    headline: 'router.headline',
    headlineList: 'router.headlineList',
    'headline-old': 'router.headlineOld',
    'headline-old-list': 'router.headlinesOldList',
    seo: 'router.seo',
    hadith: 'router.hadith',
    'hadith-list': 'router.hadithList',
    'hadith-detail': 'router.hadithDetail',
    'dream-interpretation': 'router.dreamInterpretation',
    'dream-interpretation-list': 'router.dreamInterpretationList',
    'dream-interpretation-detail': 'router.dreamInterpretationDetail',
    dua: 'router.dua',
    'dua-list': 'router.duaList',
    'dua-detail': 'router.duaDetail',
    fatwa: 'router.fatwa',
    'fatwa-list': 'router.fatwaList',
    'fatwa-detail': 'router.fatwaDetail',
    reels: 'router.reels',
    'reels-list': 'router.reelsList',
    'reels-detail': 'router.reelsDetail',
    'reels-pending-detail': 'router.reelsPendingDetail',
    story: 'router.story',
    'story-list': 'router.storyList',
    'story-detail': 'router.storyDetail',
    'story-pending-detail': 'router.storyPendingDetail',
    mailing: 'router.mailing',
    'mailing-list': 'router.mailingList',
    'mailing-detail': 'router.mailingDetail',
    'mailing-old': 'router.mailingOld',
    'mailing-old-upcoming': 'router.mailingOldUpcoming',
    'mailing-old-sent': 'router.mailingOldSent',
    settings: 'router.settings',
    'content-settings': 'router.contentSettings',
    categories: 'router.categories',
    'seo-settings': 'router.seoSettings',
    signatures: 'router.signatures',
    chefs: 'router.chefs',
    sources: 'router.sources',
    authors: 'router.authors',
    cartoonists: 'router.cartoonists',
    programs: 'router.programs',
    'headline-settings': 'router.headlineSettings',
    'headline-tags': 'router.headlineTags',
    'headline-types': 'router.headlineTypes',
    'headline-categories': 'router.headlineCategories',
    'other-settings': 'router.otherSettings',
    menu: 'router.menu',
    menus: 'router.menus',
    'menu-detail': 'router.menuDetail',
    brands: 'router.brands',
    'mailing-categories': 'router.mailingCategories',
    'system-settings': 'router.systemSettings',
    user: 'router.user',
    'user-list': 'router.userList',
    'user-detail': 'router.userDetail',
    'feature-flags': 'router.featureFlags',
    'turbo-advertisement': 'router.turboAdvertisement',
    tournaments: 'router.tournaments',
    recipe: 'router.recipe',
    recipes: 'router.recipes',
    'recipe-list': 'router.recipeList',
    'recipe-list-draft': 'router.recipeListDraft',
    'recipe-detail': 'router.recipeDetail',
    'recipe-ingredients': 'router.recipeIngredients',
    'recipe-ingredient-list': 'router.recipeIngredientList',
    'recipe-cuisines': 'router.recipeCuisines',
    'recipe-cuisines-list': 'router.recipeCuisinesList',
    'recipe-meal-types': 'router.recipeMealTypes',
    'recipe-meal-types-list': 'router.recipeMealTypesList',
    'recipe-measurements': 'router.recipeMeasurements',
    'recipe-measurements-list': 'router.recipeMeasurementsList',
    'recipe-utensils': 'router.recipeUtensils',
    'recipe-utensils-list': 'router.recipeUtensilsList',
    'recipe-healthy-lives': 'router.recipeHealthyLives',
    'recipe-healthy-lives-list': 'router.recipeHealthyLivesList',
    'recipe-steps': 'router.recipeSteps',
    'recipe-steps-list': 'router.recipeStepsList',
    'recipe-rayons': 'router.recipeRayons',
    'recipe-rayons-list': 'router.recipeRayonsList',
    'recipe-ingredient-types': 'router.recipeIngredientTypes',
    'recipe-ingredient-types-list': 'router.recipeIngredientTypesList',
    'recipe-brands': 'router.recipeBrands',
    'recipe-brand-list': 'router.recipeBrandList',
    'ai-content-list': 'router.aiContentList',
    'ai-content-detail': 'router.aiContentDetail'
  }
};
